/*
Generated time: September 4, 2024 04:50
This file was created by the app developer. Feel free to contact the original developer with any questions. It was minified (compressed) by AVADA. AVADA do NOT own this script.
*/
(window.theme = window.theme || {}),
    (window.Shopify = window.Shopify || {}),
    (theme.config = {
        bpSmall: !1,
        hasSessionStorage: !0,
        hasLocalStorage: !0,
        mediaQuerySmall: "screen and (max-width: 769px)",
        youTubeReady: !1,
        vimeoReady: !1,
        vimeoLoading: !1,
        isTouch: !!(
            "ontouchstart" in window ||
            (window.DocumentTouch && window.document instanceof DocumentTouch) ||
            window.navigator.maxTouchPoints ||
            window.navigator.msMaxTouchPoints
        ),
        stickyHeader: !1,
        rtl: "rtl" == document.documentElement.getAttribute("dir"),
    }),
    theme.config.isTouch && (document.documentElement.className += " supports-touch"),
    console &&
        console.log &&
        console.log(
            "Impulse theme (" +
                theme.settings.themeVersion +
                ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
        ),
    (theme.recentlyViewed = { recent: {}, productInfo: {} }),
    (() => {
        var H,
            D,
            d,
            l,
            F,
            j,
            B,
            R,
            N,
            U,
            i,
            z,
            Q,
            W,
            $,
            X,
            G,
            Y,
            J,
            K,
            t,
            Z,
            c,
            h,
            ee,
            u,
            te,
            ie,
            se,
            ne,
            oe,
            s,
            ae,
            re,
            ce,
            de,
            le,
            n,
            a,
            r,
            he,
            ue,
            me,
            pe,
            ge,
            fe,
            o,
            e,
            m,
            ye,
            ve,
            Se,
            be,
            we,
            Le,
            Ee,
            _e,
            p,
            g,
            f,
            Ie,
            ke,
            y,
            v,
            S,
            b,
            Ce,
            w,
            qe,
            L,
            Ae,
            xe,
            Te,
            Oe,
            Pe,
            Me,
            Ve,
            He,
            De,
            Fe,
            E,
            je,
            _,
            Be,
            I,
            Re,
            Ne,
            Ue,
            ze,
            Qe,
            We,
            $e,
            Xe,
            Ge,
            Ye,
            Je,
            Ke,
            k,
            Ze,
            et,
            tt,
            it,
            st,
            nt,
            ot,
            C,
            at,
            q,
            rt,
            A,
            x,
            T,
            O,
            ct,
            dt,
            lt,
            ht,
            ut,
            mt,
            pt,
            P,
            gt,
            M;
        function ft(e) {
            (this.container = e.container),
                (this.variants = e.variants),
                (this.singleOptionSelector = e.singleOptionSelector),
                (this.originalSelectorId = e.originalSelectorId),
                (this.enableHistoryState = e.enableHistoryState),
                (this.dynamicVariantsEnabled = e.dynamicVariantsEnabled),
                (this.currentlySelectedValues = this._getCurrentOptions()),
                (this.currentVariant = this._getVariantFromOptions()),
                this.container.querySelectorAll(this.singleOptionSelector).forEach((e) => {
                    e.addEventListener("change", this._onSelectChange.bind(this));
                });
        }
        function yt(e, t) {
            (this.divId = e),
                (this.iframe = null),
                (this.attemptedToPlay = !1),
                (N.events = {
                    onReady: this.onVideoPlayerReady.bind(this),
                    onStateChange: this.onVideoStateChange.bind(this),
                }),
                (this.options = Object.assign({}, N, t)),
                this.options &&
                    (this.options.videoParent &&
                        (this.parent = document.getElementById(this.divId).closest(this.options.videoParent)),
                    this.options.autoplay || (this.options.playerVars.autoplay = this.options.autoplay),
                    "sound" === this.options.style) &&
                    ((this.options.playerVars.controls = 1), (this.options.playerVars.autoplay = 0)),
                this.setAsLoading(),
                theme.config.youTubeReady
                    ? this.init()
                    : (theme.LibraryLoader.load("youtubeSdk"),
                      document.addEventListener("youTubeReady", this.init.bind(this)));
        }
        function vt({ sections: e, onReplace: t, debug: i } = {}) {
            (this.sections = e || []), (this.cachedSections = []), (this.onReplace = t), (this.debug = Boolean(i));
        }
        function St(e) {
            e &&
                ((this.form = e),
                (this.wrapper = e.parentNode),
                (this.location = e.dataset.location),
                (this.namespace = ".cart-" + this.location),
                (this.products = e.querySelector(z)),
                (this.submitBtn = e.querySelector(K)),
                (this.discounts = e.querySelector(W)),
                (this.savings = e.querySelector($)),
                (this.subtotal = e.querySelector(X)),
                (this.termsCheckbox = e.querySelector(J)),
                (this.noteInput = e.querySelector(Y)),
                (this.cartItemsUpdated = !1),
                this.termsCheckbox && (Z.requiresTerms = !0),
                this.init());
        }
        function bt(e) {
            if (!u) {
                u = !0;
                var e = e.currentTarget,
                    t = e.classList.contains(h.open),
                    i = e.classList.contains(h.tabs),
                    s = e.getAttribute("aria-controls"),
                    n = document.getElementById(s),
                    s = s || e.dataset.controls;
                if (s)
                    if (
                        (n ||
                            (0 < document.querySelectorAll('[data-id="' + s + '"]').length &&
                                (n = e.parentNode.querySelector('[data-id="' + s + '"]'))),
                        n)
                    ) {
                        var o = n.querySelector(c.moduleInner).offsetHeight,
                            a = n.classList.contains(h.autoHeight),
                            s = n.parentNode.closest(c.module),
                            r = o;
                        if (i) {
                            if (t) return void (u = !1);
                            document.querySelectorAll(c.tabs + '[data-id="' + e.dataset.id + '"]').forEach((e) => {
                                e.classList.remove(h.open),
                                    wt(document.querySelector("#" + e.getAttribute("aria-controls")), 0, !0);
                            });
                        }
                        t &&
                            a &&
                            setTimeout(function () {
                                wt(n, (o = 0), t, a);
                            }, 0),
                            t && !a && (o = 0),
                            e.setAttribute("aria-expanded", !t),
                            t ? e.classList.remove(h.open) : e.classList.add(h.open),
                            wt(n, o, t, a),
                            s &&
                                ((i = s.style.height),
                                t && "auto" === i && (r = 0),
                                wt(s, t ? s.offsetHeight - r : o + s.offsetHeight, !1, !1));
                    } else u = !1;
            }
        }
        function wt(e, t, i, s) {
            var n;
            e.classList.remove(h.hide),
                theme.utils.prepareTransition(e, function () {
                    (e.style.height = t + "px"), i ? e.classList.remove(h.open) : e.classList.add(h.open);
                }),
                !i && s
                    ? ((n = e),
                      window.setTimeout(function () {
                          n.css("height", "auto"), (u = !1);
                      }, 500))
                    : (u = !1);
        }
        function Lt(e) {
            (this.container = e), this._cacheSelectors(), this._setupListeners();
        }
        function Et(e, t) {
            (this.config = {
                id: e,
                close: ".js-drawer-close",
                open: ".js-drawer-open-" + t,
                openClass: "js-drawer-open",
                closingClass: "js-drawer-closing",
                activeDrawer: "drawer--is-open",
                namespace: ".drawer-" + t,
            }),
                (this.nodes = { page: document.querySelector("#MainContent") }),
                (this.drawer = document.querySelector("#" + e)),
                (this.isOpen = !1),
                this.drawer && this.init();
        }
        function V(e, t, i) {
            t = {
                close: ".js-modal-close",
                open: ".js-modal-open-" + t,
                openClass: "modal--is-active",
                closingClass: "modal--is-closing",
                bodyOpenClass: ["modal-open"],
                bodyOpenSolidClass: "modal-open--solid",
                bodyClosingClass: "modal-closing",
                closeOffContentClick: !0,
            };
            if (((this.id = e), (this.modal = document.getElementById(e)), !this.modal)) return !1;
            (this.modalContent = this.modal.querySelector(".modal__inner")),
                (this.config = Object.assign(t, i)),
                (this.modalIsOpen = !1),
                (this.focusOnOpen = this.config.focusIdOnOpen
                    ? document.getElementById(this.config.focusIdOnOpen)
                    : this.modal),
                (this.isSolid = this.config.solid),
                this.init();
        }
        (theme.delegate = {
            on: function (e, t, i) {
                return (
                    this.namespaces || (this.namespaces = {}),
                    (this.namespaces[e] = t),
                    (i = i || !1),
                    this.addEventListener(e.split(".")[0], t, i),
                    this
                );
            },
            off: function (e) {
                if (this.namespaces)
                    return (
                        this.removeEventListener(e.split(".")[0], this.namespaces[e]), delete this.namespaces[e], this
                    );
            },
        }),
            (window.on = Element.prototype.on = theme.delegate.on),
            (window.off = Element.prototype.off = theme.delegate.off),
            (theme.utils = {
                defaultTo: function (e, t) {
                    return null == e || e != e ? t : e;
                },
                wrap: function (e, t) {
                    e.parentNode.insertBefore(t, e), t.appendChild(e);
                },
                debounce: function (s, n, o) {
                    var a;
                    return function () {
                        var e = this,
                            t = arguments,
                            i = o && !a;
                        clearTimeout(a),
                            (a = setTimeout(function () {
                                (a = null), o || n.apply(e, t);
                            }, s)),
                            i && n.apply(e, t);
                    };
                },
                throttle: function (e, t) {
                    var i = !1;
                    return function () {
                        i ||
                            (t.apply(this, arguments),
                            (i = !0),
                            setTimeout(function () {
                                i = !1;
                            }, e));
                    };
                },
                prepareTransition: function (i, e) {
                    i.addEventListener("transitionend", function e(t) {
                        i.classList.remove("is-transitioning");
                        i.removeEventListener("transitionend", e);
                    }),
                        i.classList.add("is-transitioning"),
                        i.offsetWidth,
                        "function" == typeof e && e();
                },
                compact: function (e) {
                    for (var t = -1, i = null == e ? 0 : e.length, s = 0, n = []; ++t < i; ) {
                        var o = e[t];
                        o && (n[s++] = o);
                    }
                    return n;
                },
                serialize: function (e) {
                    var i = [];
                    return (
                        Array.prototype.slice.call(e.elements).forEach(function (t) {
                            !t.name ||
                                t.disabled ||
                                -1 < ["file", "reset", "submit", "button"].indexOf(t.type) ||
                                ("select-multiple" === t.type
                                    ? Array.prototype.slice.call(t.options).forEach(function (e) {
                                          e.selected &&
                                              i.push(encodeURIComponent(t.name) + "=" + encodeURIComponent(e.value));
                                      })
                                    : (-1 < ["checkbox", "radio"].indexOf(t.type) && !t.checked) ||
                                      i.push(encodeURIComponent(t.name) + "=" + encodeURIComponent(t.value)));
                        }),
                        i.join("&")
                    );
                },
            }),
            (theme.a11y = {
                trapFocus: function (t) {
                    var i = {
                            focusin: t.namespace ? "focusin." + t.namespace : "focusin",
                            focusout: t.namespace ? "focusout." + t.namespace : "focusout",
                            keydown: t.namespace ? "keydown." + t.namespace : "keydown.handleFocus",
                        },
                        e = t.container.querySelectorAll(
                            'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
                        ),
                        e = [].slice.call(e).filter((e) => null !== e.offsetParent),
                        s = e[0],
                        n = e[e.length - 1];
                    t.elementToFocus || (t.elementToFocus = t.container),
                        t.container.setAttribute("tabindex", "-1"),
                        t.elementToFocus.focus(),
                        document.documentElement.off("focusin"),
                        document.documentElement.on(i.focusout, function () {
                            document.documentElement.off(i.keydown);
                        }),
                        document.documentElement.on(i.focusin, function (e) {
                            (e.target !== t.container && e.target !== n && e.target !== s) ||
                                document.documentElement.on(i.keydown, function (e) {
                                    9 !== (e = e).keyCode ||
                                        e.target !== n ||
                                        e.shiftKey ||
                                        (e.preventDefault(), s.focus());
                                });
                        });
                },
                removeTrapFocus: function (e) {
                    var t = e.namespace ? "focusin." + e.namespace : "focusin";
                    e.container && e.container.removeAttribute("tabindex"), document.documentElement.off(t);
                },
                lockMobileScrolling: function (e, t) {
                    t = t || document.documentElement;
                    document.documentElement.classList.add("lock-scroll"),
                        t.on("touchmove" + e, function () {
                            return !0;
                        });
                },
                unlockMobileScrolling: function (e, t) {
                    document.documentElement.classList.remove("lock-scroll"),
                        (t || document.documentElement).off("touchmove" + e);
                },
            }),
            document.documentElement.on("keyup.tab", function (e) {
                9 === e.keyCode &&
                    (document.documentElement.classList.add("tab-outline"), document.documentElement.off("keyup.tab"));
            }),
            (theme.Currency =
                ((H = theme && theme.settings && theme.settings.superScriptPrice),
                {
                    formatMoney: function (e, t) {
                        (t = t || theme.settings.moneyFormat), "string" == typeof e && (e = e.replace(".", ""));
                        var i = "",
                            s = /\{\{\s*(\w+)\s*\}\}/;
                        function n(e, t, i, s) {
                            return (
                                (t = theme.utils.defaultTo(t, 2)),
                                (i = theme.utils.defaultTo(i, ",")),
                                (s = theme.utils.defaultTo(s, ".")),
                                isNaN(e) || null == e
                                    ? 0
                                    : (t = (e = (e / 100).toFixed(t)).split("."))[0].replace(
                                          /(\d)(?=(\d\d\d)+(?!\d))/g,
                                          "$1" + i
                                      ) + (t[1] ? s + t[1] : "")
                            );
                        }
                        switch ((t = t || "${{amount}}").match(s)[1]) {
                            case "amount":
                                (i = n(e, 2)), H && i && i.includes(".") && (i = i.replace(".", "<sup>") + "</sup>");
                                break;
                            case "amount_no_decimals":
                                i = n(e, 0);
                                break;
                            case "amount_with_comma_separator":
                                (i = n(e, 2, ".", ",")),
                                    H && i && i.includes(",") && (i = i.replace(",", "<sup>") + "</sup>");
                                break;
                            case "amount_no_decimals_with_comma_separator":
                                i = n(e, 0, ".", ",");
                                break;
                            case "amount_no_decimals_with_space_separator":
                                i = n(e, 0, " ");
                        }
                        return t.replace(s, i);
                    },
                    getBaseUnit: function (e) {
                        if (e && e.unit_price_measurement && e.unit_price_measurement.reference_value)
                            return 1 === e.unit_price_measurement.reference_value
                                ? e.unit_price_measurement.reference_unit
                                : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
                    },
                })),
            (theme.Images = {
                imageSize: function (e) {
                    return e
                        ? null !==
                          (e = e.match(
                              /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
                          ))
                            ? e[1]
                            : null
                        : "620x";
                },
                getSizedImageUrl: function (e, t) {
                    var i;
                    return (
                        e &&
                        (null == t
                            ? e
                            : "master" === t
                              ? this.removeProtocol(e)
                              : null != (i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i))
                                ? ((e = e.split(i[0])), (i = i[0]), this.removeProtocol(e[0] + "_" + t + i))
                                : null)
                    );
                },
                removeProtocol: function (e) {
                    return e.replace(/http(s)?:/, "");
                },
                buildImagePath: function (s, n) {
                    if (null == s) return [];
                    if (n) {
                        let i = [];
                        return (
                            n.forEach((e) => {
                                let t = s + "?width=" + e;
                                e === n[n.length - 1] ? (t += ` ${e}w`) : (t += ` ${e}w,`), i.push(t);
                            }),
                            i
                        );
                    }
                    return [s];
                },
            }),
            (theme.initWhenVisible = function (i) {
                var e = i.threshold || 0;
                new IntersectionObserver(
                    (e, t) => {
                        e.forEach((e) => {
                            e.isIntersecting &&
                                "function" == typeof i.callback &&
                                (i.callback(), t.unobserve(e.target));
                        });
                    },
                    { rootMargin: "0px 0px " + e + "px 0px" }
                ).observe(i.element);
            }),
            (theme.LibraryLoader =
                ((l = { requested: "requested", loaded: "loaded" }),
                (F = {
                    youtubeSdk: {
                        tagId: "youtube-sdk",
                        src: "https://www.youtube.com/iframe_api",
                        type: (d = "script"),
                    },
                    vimeo: { tagId: "vimeo-api", src: "https://player.vimeo.com/api/player.js", type: d },
                    shopifyXr: {
                        tagId: "shopify-model-viewer-xr",
                        src:
                            (M = "https://cdn.shopify.com/shopifycloud/") +
                            "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
                        type: d,
                    },
                    modelViewerUi: {
                        tagId: "shopify-model-viewer-ui",
                        src: M + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
                        type: d,
                    },
                    modelViewerUiStyles: {
                        tagId: "shopify-model-viewer-ui-styles",
                        src: M + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
                        type: (D = "link"),
                    },
                }),
                {
                    load: function (e, t) {
                        var i,
                            s,
                            n,
                            o,
                            a,
                            r,
                            c = F[e];
                        if (c && c.status !== l.requested)
                            if (((t = t || function () {}), c.status === l.loaded)) t();
                            else {
                                switch (((c.status = l.requested), c.type)) {
                                    case d:
                                        (o = c),
                                            (a = t),
                                            ((r = document.createElement("script")).src = o.src),
                                            r.addEventListener("load", function () {
                                                (o.status = l.loaded), a();
                                            }),
                                            (i = r);
                                        break;
                                    case D:
                                        (s = c),
                                            (n = t),
                                            ((r = document.createElement("link")).href = s.src),
                                            (r.rel = "stylesheet"),
                                            (r.type = "text/css"),
                                            r.addEventListener("load", function () {
                                                (s.status = l.loaded), n();
                                            }),
                                            (i = r);
                                }
                                (i.id = c.tagId), (c.element = i);
                                e = document.getElementsByTagName(c.type)[0];
                                e.parentNode.insertBefore(i, e);
                            }
                    },
                })),
            (theme.rteInit = function () {
                function t(e) {
                    e.src = e.src;
                    var t = document.createElement("div");
                    t.classList.add("video-wrapper"), theme.utils.wrap(e, t);
                }
                document.querySelectorAll(".rte table").forEach((e) => {
                    var t = document.createElement("div");
                    t.classList.add("table-wrapper"), theme.utils.wrap(e, t);
                }),
                    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach((e) => {
                        t(e);
                    }),
                    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach((e) => {
                        t(e);
                    }),
                    document.querySelectorAll(".rte a img").forEach((e) => {
                        e.parentNode.classList.add("rte__image");
                    });
            }),
            (theme.Sections = function () {
                (this.constructors = {}),
                    (this.instances = []),
                    document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this)),
                    document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this)),
                    document.addEventListener("shopify:section:select", this._onSelect.bind(this)),
                    document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this)),
                    document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this)),
                    document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
            }),
            (theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
                _createInstance: function (e, t, i) {
                    var s = e.getAttribute("data-section-id"),
                        n = e.getAttribute("data-section-type");
                    if (void 0 !== (t = t || this.constructors[n])) {
                        i && this._findInstance(s) && this._removeInstance(s);
                        try {
                            var o = Object.assign(new t(e), { id: s, type: n, container: e });
                            this.instances.push(o);
                        } catch (e) {
                            console.error(e);
                        }
                    }
                },
                _findInstance: function (e) {
                    for (var t = 0; t < this.instances.length; t++)
                        if (this.instances[t].id === e) return this.instances[t];
                },
                _removeInstance: function (e) {
                    for (var t, i = this.instances.length; i--; )
                        if (this.instances[i].id === e) {
                            (t = this.instances[i]), this.instances.splice(i, 1);
                            break;
                        }
                    return t;
                },
                _onSectionLoad: function (e, t, i) {
                    window.AOS && AOS.refreshHard(), theme && theme.initGlobals && theme.initGlobals();
                    var s = t || e.target,
                        n = t || e.target.querySelector("[data-section-id]");
                    n &&
                        (this._createInstance(n),
                        (n = t ? i : this._findInstance(e.detail.sectionId)),
                        s.querySelectorAll("[data-subsection]").length && this.loadSubSections(s),
                        n && "function" == typeof n.onLoad && n.onLoad(e),
                        setTimeout(function () {
                            window.dispatchEvent(new Event("scroll"));
                        }, 200));
                },
                _onSectionUnload: function (i) {
                    this.instances = this.instances.filter(function (e) {
                        var t = e.id === i.detail.sectionId;
                        return t && "function" == typeof e.onUnload && e.onUnload(i), !t;
                    });
                },
                loadSubSections: function (e) {
                    e &&
                        e.querySelectorAll("[data-section-id]").forEach((e) => {
                            this._onSectionLoad(null, e, e.dataset.sectionId);
                        });
                },
                _onSelect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    void 0 !== t && "function" == typeof t.onSelect && t.onSelect(e);
                },
                _onDeselect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    void 0 !== t && "function" == typeof t.onDeselect && t.onDeselect(e);
                },
                _onBlockSelect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    void 0 !== t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                },
                _onBlockDeselect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    void 0 !== t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
                },
                register: function (e, t, i) {
                    this.constructors[e] = t;
                    var s = document.querySelectorAll('[data-section-type="' + e + '"]');
                    (s = i ? i.querySelectorAll('[data-section-type="' + e + '"]') : s).forEach(
                        function (e) {
                            this._createInstance(e, t, i);
                        }.bind(this)
                    );
                },
                reinit: function (e) {
                    for (var t = 0; t < this.instances.length; t++) {
                        var i = this.instances[t];
                        i.type === e && "function" == typeof i.forceReload && i.forceReload();
                    }
                },
            })),
            (theme.Variants =
                ((ft.prototype = Object.assign({}, ft.prototype, {
                    _getCurrentOptions: function () {
                        var i = [];
                        return (
                            this.container.querySelectorAll(this.singleOptionSelector).forEach((e) => {
                                var t = e.getAttribute("type");
                                (("radio" !== t && "checkbox" !== t) || e.checked) &&
                                    i.push({ value: e.value, index: e.dataset.index });
                            }),
                            (i = theme.utils.compact(i))
                        );
                    },
                    _numberFromOptionKey: function (e) {
                        return parseInt(e.substr(-1));
                    },
                    _getWeightedOptionMatchCount: function (n) {
                        return this._getCurrentOptions().reduce((e, { value: t, index: i }) => {
                            var s = this._numberFromOptionKey(i);
                            return n[i] === t ? e + (4 - s) : e;
                        }, 0);
                    },
                    _getFullMatch(t) {
                        let s = this._getCurrentOptions();
                        return this.variants.find((i) => {
                            var e = s.every(({ value: e, index: t }) => i[t] === e);
                            return t ? e && i.available : e;
                        });
                    },
                    _getClosestAvailableMatch: function (s) {
                        if (!s) return null;
                        let e = this._getCurrentOptions();
                        var t = this.variants;
                        return (
                            s &&
                            t.filter(
                                (i) =>
                                    e
                                        .filter(
                                            ({ index: e }) =>
                                                this._numberFromOptionKey(e) <= this._numberFromOptionKey(s.index)
                                        )
                                        .every(({ value: e, index: t }) => i[t] === e) && i.available
                            )
                        ).reduce(
                            (e, t) =>
                                null === e ||
                                this._getWeightedOptionMatchCount(e, s) < this._getWeightedOptionMatchCount(t, s)
                                    ? t
                                    : e,
                            null
                        );
                    },
                    _getVariantFromOptions: function (e) {
                        var t = this._getFullMatch(!0),
                            e = this._getClosestAvailableMatch(e),
                            i = this._getFullMatch(!1);
                        return this.dynamicVariantsEnabled ? t || e || i || null : i || null;
                    },
                    _updateInputState: function (n, e) {
                        return (e) => {
                            var t, i, s;
                            null !== n &&
                                ((t = e.dataset.index),
                                (i = e.value),
                                "radio" === (s = e.getAttribute("type")) || "checkbox" === s
                                    ? (e.checked = n[t] === i)
                                    : (e.value = n[t]));
                        };
                    },
                    _onSelectChange: function ({ srcElement: e }) {
                        var t = this.container.querySelectorAll(this.singleOptionSelector),
                            i = this._getVariantFromOptions({ index: e.dataset.index, value: e.value }),
                            t =
                                (t.forEach(this._updateInputState(i, e)),
                                (this.currentlySelectedValues = this._getCurrentOptions())),
                            t = {
                                variant: i,
                                currentlySelectedValues: t,
                                value: e.value,
                                index: e.parentElement.dataset.index,
                            };
                        this.container.dispatchEvent(new CustomEvent("variantChange", { detail: t })),
                            document.dispatchEvent(new CustomEvent("variant:change", { detail: t })),
                            i &&
                                (this._updateMasterSelect(i),
                                this._updateImages(i),
                                this._updatePrice(i),
                                this._updateUnitPrice(i),
                                this._updateSKU(i),
                                (this.currentVariant = i),
                                this.enableHistoryState) &&
                                this._updateHistoryState(i);
                    },
                    _updateImages: function (e) {
                        e.featured_image &&
                            this.container.dispatchEvent(
                                new CustomEvent("variantImageChange", { detail: { variant: e } })
                            );
                    },
                    _updatePrice: function (e) {
                        (this.currentVariant &&
                            e.price === this.currentVariant.price &&
                            e.compare_at_price === this.currentVariant.compare_at_price) ||
                            this.container.dispatchEvent(
                                new CustomEvent("variantPriceChange", { detail: { variant: e } })
                            );
                    },
                    _updateUnitPrice: function (e) {
                        (this.currentVariant && e.unit_price === this.currentVariant.unit_price) ||
                            this.container.dispatchEvent(
                                new CustomEvent("variantUnitPriceChange", { detail: { variant: e } })
                            );
                    },
                    _updateSKU: function (e) {
                        (this.currentVariant && e.sku === this.currentVariant.sku) ||
                            this.container.dispatchEvent(
                                new CustomEvent("variantSKUChange", { detail: { variant: e } })
                            );
                    },
                    _updateHistoryState: function (e) {
                        history.replaceState &&
                            e &&
                            ((e =
                                window.location.protocol +
                                "//" +
                                window.location.host +
                                window.location.pathname +
                                "?variant=" +
                                e.id),
                            window.history.replaceState({ path: e }, "", e));
                    },
                    _updateMasterSelect: function (e) {
                        var t = this.container.querySelector(this.originalSelectorId);
                        t && ((t.value = e.id), t.dispatchEvent(new Event("change", { bubbles: !0 })));
                    },
                })),
                ft)),
            (window.vimeoApiReady = function () {
                (theme.config.vimeoLoading = !0),
                    (() => {
                        let i, s;
                        return new Promise((e, t) => {
                            (i = setInterval(function () {
                                Vimeo && (clearInterval(i), clearTimeout(s), e());
                            }, 500)),
                                (s = setTimeout(function () {
                                    clearInterval(i), t();
                                }, 4e3));
                        });
                    })().then(function () {
                        (theme.config.vimeoReady = !0),
                            (theme.config.vimeoLoading = !1),
                            document.dispatchEvent(new CustomEvent("vimeoReady"));
                    });
            }),
            (theme.VimeoPlayer = (() => {
                let e = { loading: "loading", loaded: "loaded", interactable: "video-interactable" },
                    t = { byline: !1, loop: !0, muted: !0, playsinline: !0, portrait: !1, title: !1 };
                function i(e, t, i) {
                    (this.divId = e),
                        (this.el = document.getElementById(e)),
                        (this.videoId = t),
                        (this.iframe = null),
                        (this.options = i),
                        this.options &&
                            this.options.videoParent &&
                            (this.parent = this.el.closest(this.options.videoParent)),
                        this.setAsLoading(),
                        theme.config.vimeoReady
                            ? this.init()
                            : (theme.LibraryLoader.load("vimeo", window.vimeoApiReady),
                              document.addEventListener("vimeoReady", this.init.bind(this)));
                }
                return (
                    (i.prototype = Object.assign({}, i.prototype, {
                        init: function () {
                            var e = t;
                            (e.id = this.videoId),
                                (this.videoPlayer = new Vimeo.Player(this.el, e)),
                                this.videoPlayer.ready().then(this.playerReady.bind(this));
                        },
                        playerReady: function () {
                            (this.iframe = this.el.querySelector("iframe")),
                                this.iframe.setAttribute("tabindex", "-1"),
                                "false" === this.options.loop && this.videoPlayer.setLoop(!1),
                                "sound" === this.options.style
                                    ? this.videoPlayer.setVolume(1)
                                    : this.videoPlayer.setVolume(0),
                                this.setAsLoaded(),
                                new IntersectionObserver(
                                    (e, t) => {
                                        e.forEach((e) => {
                                            e.isIntersecting ? this.play() : this.pause();
                                        });
                                    },
                                    { rootMargin: "0px 0px 50px 0px" }
                                ).observe(this.iframe);
                        },
                        setAsLoading: function () {
                            this.parent && this.parent.classList.add(e.loading);
                        },
                        setAsLoaded: function () {
                            this.parent &&
                                (this.parent.classList.remove(e.loading),
                                this.parent.classList.add(e.loaded),
                                this.parent.classList.add(e.interactable),
                                Shopify) &&
                                Shopify.designMode &&
                                window.AOS &&
                                AOS.refreshHard();
                        },
                        enableInteraction: function () {
                            this.parent && this.parent.classList.add(e.interactable);
                        },
                        play: function () {
                            this.videoPlayer && "function" == typeof this.videoPlayer.play && this.videoPlayer.play();
                        },
                        pause: function () {
                            this.videoPlayer && "function" == typeof this.videoPlayer.pause && this.videoPlayer.pause();
                        },
                        destroy: function () {
                            this.videoPlayer &&
                                "function" == typeof this.videoPlayer.destroy &&
                                this.videoPlayer.destroy();
                        },
                    })),
                    i
                );
            })()),
            (window.onYouTubeIframeAPIReady = function () {
                (theme.config.youTubeReady = !0), document.dispatchEvent(new CustomEvent("youTubeReady"));
            }),
            (theme.YouTube =
                ((j = "loading"),
                (B = "loaded"),
                (R = "video-interactable"),
                (N = {
                    width: 1280,
                    height: 720,
                    playerVars: {
                        autohide: 0,
                        autoplay: 1,
                        cc_load_policy: 0,
                        controls: 0,
                        fs: 0,
                        iv_load_policy: 3,
                        modestbranding: 1,
                        playsinline: 1,
                        rel: 0,
                    },
                }),
                (yt.prototype = Object.assign({}, yt.prototype, {
                    init: function () {
                        this.videoPlayer = new YT.Player(this.divId, this.options);
                    },
                    onVideoPlayerReady: function (e) {
                        (this.iframe = document.getElementById(this.divId)),
                            this.iframe.setAttribute("tabindex", "-1"),
                            "sound" !== this.options.style && e.target.mute(),
                            new IntersectionObserver(
                                (e, t) => {
                                    e.forEach((e) => {
                                        e.isIntersecting ? this.play() : this.pause();
                                    });
                                },
                                { rootMargin: "0px 0px 50px 0px" }
                            ).observe(this.iframe);
                    },
                    onVideoStateChange: function (e) {
                        switch (e.data) {
                            case -1:
                                this.attemptedToPlay && (this.setAsLoaded(), this.enableInteraction());
                                break;
                            case 0:
                                this.play(e);
                                break;
                            case 1:
                                this.setAsLoaded();
                                break;
                            case 3:
                                this.attemptedToPlay = !0;
                        }
                    },
                    setAsLoading: function () {
                        this.parent && this.parent.classList.add(j);
                    },
                    setAsLoaded: function () {
                        this.parent &&
                            (this.parent.classList.remove(j), this.parent.classList.add(B), Shopify) &&
                            Shopify.designMode &&
                            window.AOS &&
                            AOS.refreshHard();
                    },
                    enableInteraction: function () {
                        this.parent && this.parent.classList.add(R);
                    },
                    play: function () {
                        this.videoPlayer &&
                            "function" == typeof this.videoPlayer.playVideo &&
                            this.videoPlayer.playVideo();
                    },
                    pause: function () {
                        this.videoPlayer &&
                            "function" == typeof this.videoPlayer.pauseVideo &&
                            this.videoPlayer.pauseVideo();
                    },
                    destroy: function () {
                        this.videoPlayer && "function" == typeof this.videoPlayer.destroy && this.videoPlayer.destroy();
                    },
                })),
                yt)),
            (i = !1),
            document.body.addEventListener("touchstart", function (e) {
                if (!e.target.closest(".flickity-slider")) return (i = !1);
                (i = !0), (U = { x: e.touches[0].pageX, y: e.touches[0].pageY });
            }),
            document.body.addEventListener(
                "touchmove",
                function (e) {
                    var t;
                    i &&
                        e.cancelable &&
                        ((t = { x: e.touches[0].pageX - U.x, y: e.touches[0].pageY - U.y }),
                        Math.abs(t.x) > Flickity.defaults.dragThreshold) &&
                        e.preventDefault();
                },
                { passive: !1 }
            ),
            (theme.AjaxRenderer =
                ((vt.prototype = Object.assign({}, vt.prototype, {
                    renderPage: function (s, e, t = !0) {
                        var i = new URLSearchParams(window.location.search);
                        let n = this.getUpdatedParams(i, e);
                        i = this.sections.map((e) => {
                            let t = `${s}?section_id=${e.sectionId}&` + n.toString();
                            var i = (e) => e.url === t;
                            return this.cachedSections.some(i)
                                ? this.renderSectionFromCache(i, e)
                                : this.renderSectionFromFetch(t, e);
                        });
                        return t && this.updateURLHash(n), Promise.all(i);
                    },
                    renderSectionFromCache: function (e, t) {
                        e = this.cachedSections.find(e);
                        return (
                            this.log("[AjaxRenderer] rendering from cache: url=" + e.url),
                            this.renderSection(e.html, t),
                            Promise.resolve(t)
                        );
                    },
                    renderSectionFromFetch: function (s, n) {
                        return (
                            this.log("[AjaxRenderer] redering from fetch: url=" + s),
                            new Promise((t, i) => {
                                fetch(s)
                                    .then((e) => e.text())
                                    .then((e) => {
                                        (this.cachedSections = [...this.cachedSections, { html: e, url: s }]),
                                            this.renderSection(e, n),
                                            t(n);
                                    })
                                    .catch((e) => i(e));
                            })
                        );
                    },
                    renderSection: function (e, t) {
                        this.log("[AjaxRenderer] rendering section: section=" + JSON.stringify(t));
                        let i = new DOMParser().parseFromString(e, "text/html");
                        if (this.onReplace) this.onReplace(i, t);
                        else if ("string" == typeof t.nodeId) {
                            e = i.getElementById(t.nodeId);
                            if (!e) return;
                            document.getElementById(t.nodeId).innerHTML = e.innerHTML;
                        } else
                            t.nodeId.forEach((e) => {
                                document.getElementById(e).innerHTML = i.getElementById(e).innerHTML;
                            });
                        return t;
                    },
                    getUpdatedParams: function (e, t) {
                        var i,
                            s,
                            n,
                            o,
                            a = new URLSearchParams(e),
                            r = ["sort_by", "q", "options[prefix]", "type"];
                        for ([i, s] of a.entries()) t.getAll(i).includes(s) || r.includes(i) || a.delete(i);
                        for ([n, o] of t.entries()) a.getAll(n).includes(o) || "" === o || a.append(n, o);
                        return a;
                    },
                    updateURLHash: function (e) {
                        history.pushState({}, "", "" + window.location.pathname + (e && "?".concat(e)));
                    },
                    log: function (...e) {
                        this.debug && console.log(...e);
                    },
                })),
                vt)),
            window.Shopify &&
                window.Shopify.theme &&
                navigator &&
                navigator.sendBeacon &&
                window.Shopify.designMode &&
                navigator.sendBeacon(
                    "https://api.archetypethemes.co/api/beacon",
                    new URLSearchParams({
                        shop: window.Shopify.shop,
                        themeName:
                            window.theme &&
                            window.theme.settings &&
                            window.theme.settings.themeName + " v" + window.theme.settings.themeVersion,
                        role: window.Shopify.theme.role,
                        route: window.location.pathname,
                        themeId: window.Shopify.theme.id,
                        themeStoreId: window.Shopify.theme.theme_store_id || 0,
                        isThemeEditor: !!window.Shopify.designMode,
                    })
                ),
            (theme.cart = {
                getCart: function () {
                    var e = "".concat(theme.routes.cart, "?t=").concat(Date.now());
                    return fetch(e, { credentials: "same-origin", method: "GET" }).then((e) => e.json());
                },
                getCartProductMarkup: function () {
                    var e =
                        -1 === (e = "".concat(theme.routes.cartPage, "?t=").concat(Date.now())).indexOf("?")
                            ? e + "?view=ajax"
                            : e + "&view=ajax";
                    return fetch(e, { credentials: "same-origin", method: "GET" })
                        .then((e) => e.text())
                        .catch((e) => console.error(e));
                },
                changeItem: function (e, t) {
                    return this._updateCart({
                        url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
                        data: JSON.stringify({ id: e, quantity: t }),
                    });
                },
                _updateCart: function (e) {
                    return fetch(e.url, {
                        method: "POST",
                        body: e.data,
                        credentials: "same-origin",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest",
                            Accept: "application/json",
                        },
                    })
                        .then((e) => e.text())
                        .then((e) => e);
                },
                updateAttribute: function (e, t) {
                    return this._updateCart({
                        url: "/cart/update.js",
                        data: JSON.stringify({ attributes: { [e]: theme.cart.attributeToString(t) } }),
                    });
                },
                updateNote: function (e) {
                    return this._updateCart({
                        url: "/cart/update.js",
                        data: JSON.stringify({ note: theme.cart.attributeToString(e) }),
                    });
                },
                attributeToString: function (e) {
                    return (e = "string" != typeof e && "undefined" === (e += "") ? "" : e).trim();
                },
            }),
            (theme.CartForm =
                ((z = "[data-products]"),
                (Q = ".js-qty__wrapper"),
                (W = "[data-discounts]"),
                ($ = "[data-savings]"),
                (X = "[data-subtotal]"),
                (G = ".cart-link__bubble"),
                (Y = '[name="note"]'),
                (J = ".cart__terms-checkbox"),
                (K = ".cart__checkout"),
                (Z = { requiresTerms: !(t = "btn--loading") }),
                (St.prototype = Object.assign({}, St.prototype, {
                    init: function () {
                        this.initQtySelectors(),
                            document.addEventListener(
                                "cart:quantity" + this.namespace,
                                this.quantityChanged.bind(this)
                            ),
                            this.form.on("submit" + this.namespace, this.onSubmit.bind(this)),
                            this.noteInput &&
                                this.noteInput.addEventListener("change", function () {
                                    var e = this.value;
                                    theme.cart.updateNote(e);
                                }),
                            document.addEventListener(
                                "cart:build",
                                function () {
                                    this.buildCart();
                                }.bind(this)
                            );
                    },
                    reInit: function () {
                        this.initQtySelectors();
                    },
                    onSubmit: function (e) {
                        return (
                            this.submitBtn.classList.add(t),
                            (document.documentElement.classList.contains("js-drawer-open") && this.cartItemsUpdated) ||
                            (document.documentElement.classList.contains("cart-open") && this.cartItemsUpdated)
                                ? (this.submitBtn.classList.remove(t), e.preventDefault(), !1)
                                : Z.requiresTerms && !this.termsCheckbox.checked
                                  ? (alert(theme.strings.cartTermsConfirmation),
                                    this.submitBtn.classList.remove(t),
                                    e.preventDefault(),
                                    !1)
                                  : void 0
                        );
                    },
                    _parseProductHTML: function (e) {
                        var t = document.createElement("div");
                        return (
                            (t.innerHTML = e),
                            { items: t.querySelector(".cart__items"), discounts: t.querySelector(".cart__discounts") }
                        );
                    },
                    buildCart: function () {
                        theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
                    },
                    cartMarkup: function (e) {
                        var e = this._parseProductHTML(e),
                            t = e.items,
                            i = parseInt(t.dataset.count),
                            s = t.dataset.cartSubtotal,
                            n = t.dataset.cartSavings;
                        this.updateCartDiscounts(e.discounts),
                            this.updateSavings(n),
                            0 < i ? this.wrapper.classList.remove("is-empty") : this.wrapper.classList.add("is-empty"),
                            this.updateCount(i),
                            (this.products.innerHTML = ""),
                            this.products.append(t),
                            (this.subtotal.innerHTML = theme.Currency.formatMoney(s, theme.settings.moneyFormat)),
                            this.reInit(),
                            window.AOS && AOS.refreshHard(),
                            Shopify &&
                                Shopify.StorefrontExpressButtons &&
                                Shopify.StorefrontExpressButtons.initialize();
                    },
                    updateCartDiscounts: function (e) {
                        this.discounts && ((this.discounts.innerHTML = ""), this.discounts.append(e));
                    },
                    initQtySelectors: function () {
                        this.form.querySelectorAll(Q).forEach((e) => {
                            new theme.QtySelector(e, { namespace: this.namespace, isCart: !0 });
                        });
                    },
                    quantityChanged: function (i) {
                        var s = i.detail[0],
                            e = i.detail[1],
                            t = i.detail[2];
                        s &&
                            e &&
                            (t && t.classList.add("is-loading"),
                            theme.cart
                                .changeItem(s, e)
                                .then(
                                    function (e) {
                                        var t,
                                            e = JSON.parse(e);
                                        422 === e.status
                                            ? alert(e.message)
                                            : (!(t = e.items.find((e) => e.key === s)) ||
                                                  ("cart:quantity.cart-cart-drawer" !== i.type &&
                                                      "cart:quantity.cart-header" !== i.type) ||
                                                  (this.cartItemsUpdated = !0),
                                              ((t && "cart:quantity.cart-cart-drawer" === i.type) ||
                                                  (t && "cart:quantity.cart-header" === i.type)) &&
                                                  (t.quantity, (this.cartItemsUpdated = !1)),
                                              0 < e.item_count
                                                  ? this.wrapper.classList.remove("is-empty")
                                                  : this.wrapper.classList.add("is-empty")),
                                            this.buildCart(),
                                            document.dispatchEvent(
                                                new CustomEvent("cart:updated", { detail: { cart: e } })
                                            );
                                    }.bind(this)
                                )
                                .catch(function (e) {}));
                    },
                    updateSubtotal: function (e) {
                        this.form.querySelector(X).innerHTML = theme.Currency.formatMoney(
                            e,
                            theme.settings.moneyFormat
                        );
                    },
                    updateSavings: function (e) {
                        this.savings &&
                            (0 < e
                                ? ((e = theme.Currency.formatMoney(e, theme.settings.moneyFormat)),
                                  this.savings.classList.remove("hide"),
                                  (this.savings.innerHTML = theme.strings.cartSavings.replace("[savings]", e)))
                                : this.savings.classList.add("hide"));
                    },
                    updateCount: function (t) {
                        var e = document.querySelectorAll(".cart-link__bubble-num"),
                            e =
                                (e.length &&
                                    e.forEach((e) => {
                                        e.innerText = t;
                                    }),
                                document.querySelectorAll(G));
                        e.length &&
                            (0 < t
                                ? e.forEach((e) => {
                                      e.classList.add("cart-link__bubble--visible");
                                  })
                                : e.forEach((e) => {
                                      e.classList.remove("cart-link__bubble--visible");
                                  }));
                    },
                })),
                St)),
            (theme.collapsibles =
                ((c = {
                    trigger: ".collapsible-trigger",
                    module: ".collapsible-content",
                    moduleInner: ".collapsible-content__inner",
                    tabs: ".collapsible-trigger--tab",
                }),
                (h = {
                    hide: "hide",
                    open: "is-open",
                    autoHeight: "collapsible--auto-height",
                    tabs: "collapsible-trigger--tab",
                }),
                (u = !(ee = ".collapsible")),
                {
                    init: function (e) {
                        (e || document).querySelectorAll(c.trigger).forEach((e) => {
                            var t = e.classList.contains(h.open);
                            e.setAttribute("aria-expanded", t), e.off("click" + ee), e.on("click" + ee, bt);
                        });
                    },
                })),
            (theme.Disclosure =
                ((te = "[data-disclosure-form]"),
                (ie = "[data-disclosure-list]"),
                (se = "[data-disclosure-toggle]"),
                (ne = "[data-disclosure-input]"),
                (oe = "[data-disclosure-option]"),
                (s = "disclosure-list--visible"),
                (Lt.prototype = Object.assign({}, Lt.prototype, {
                    _cacheSelectors: function () {
                        this.cache = {
                            disclosureForm: this.container.closest(te),
                            disclosureList: this.container.querySelector(ie),
                            disclosureToggle: this.container.querySelector(se),
                            disclosureInput: this.container.querySelector(ne),
                            disclosureOptions: this.container.querySelectorAll(oe),
                        };
                    },
                    _setupListeners: function () {
                        (this.eventHandlers = this._setupEventHandlers()),
                            this.cache.disclosureToggle.addEventListener("click", this.eventHandlers.toggleList),
                            this.cache.disclosureOptions.forEach(function (e) {
                                e.addEventListener("click", this.eventHandlers.connectOptions);
                            }, this),
                            this.container.addEventListener("keyup", this.eventHandlers.onDisclosureKeyUp),
                            this.cache.disclosureList.addEventListener(
                                "focusout",
                                this.eventHandlers.onDisclosureListFocusOut
                            ),
                            this.cache.disclosureToggle.addEventListener(
                                "focusout",
                                this.eventHandlers.onDisclosureToggleFocusOut
                            ),
                            document.body.addEventListener("click", this.eventHandlers.onBodyClick);
                    },
                    _setupEventHandlers: function () {
                        return {
                            connectOptions: this._connectOptions.bind(this),
                            toggleList: this._toggleList.bind(this),
                            onBodyClick: this._onBodyClick.bind(this),
                            onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
                            onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
                            onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this),
                        };
                    },
                    _connectOptions: function (e) {
                        e.preventDefault(), this._submitForm(e.currentTarget.dataset.value);
                    },
                    _onDisclosureToggleFocusOut: function (e) {
                        !1 === this.container.contains(e.relatedTarget) && this._hideList();
                    },
                    _onDisclosureListFocusOut: function (e) {
                        e = e.currentTarget.contains(e.relatedTarget);
                        this.cache.disclosureList.classList.contains(s) && !e && this._hideList();
                    },
                    _onDisclosureKeyUp: function (e) {
                        27 === e.which && (this._hideList(), this.cache.disclosureToggle.focus());
                    },
                    _onBodyClick: function (e) {
                        e = this.container.contains(e.target);
                        this.cache.disclosureList.classList.contains(s) && !e && this._hideList();
                    },
                    _submitForm: function (e) {
                        (this.cache.disclosureInput.value = e), this.cache.disclosureForm.submit();
                    },
                    _hideList: function () {
                        this.cache.disclosureList.classList.remove(s),
                            this.cache.disclosureToggle.setAttribute("aria-expanded", !1);
                    },
                    _toggleList: function () {
                        var e = "true" === this.cache.disclosureToggle.getAttribute("aria-expanded");
                        this.cache.disclosureList.classList.toggle(s),
                            this.cache.disclosureToggle.setAttribute("aria-expanded", !e);
                    },
                    destroy: function () {
                        this.cache.disclosureToggle.removeEventListener("click", this.eventHandlers.toggleList),
                            this.cache.disclosureOptions.forEach(function (e) {
                                e.removeEventListener("click", this.eventHandlers.connectOptions);
                            }, this),
                            this.container.removeEventListener("keyup", this.eventHandlers.onDisclosureKeyUp),
                            this.cache.disclosureList.removeEventListener(
                                "focusout",
                                this.eventHandlers.onDisclosureListFocusOut
                            ),
                            this.cache.disclosureToggle.removeEventListener(
                                "focusout",
                                this.eventHandlers.onDisclosureToggleFocusOut
                            ),
                            document.body.removeEventListener("click", this.eventHandlers.onBodyClick);
                    },
                })),
                Lt)),
            (theme.Drawers =
                ((Et.prototype = Object.assign({}, Et.prototype, {
                    init: function () {
                        document.querySelectorAll(this.config.open).forEach((e) => {
                            e.setAttribute("aria-expanded", "false"), e.addEventListener("click", this.open.bind(this));
                        }),
                            this.drawer
                                .querySelector(this.config.close)
                                .addEventListener("click", this.close.bind(this)),
                            document.addEventListener(
                                "modalOpen",
                                function () {
                                    this.close();
                                }.bind(this)
                            );
                    },
                    open: function (e, t) {
                        e && e.preventDefault(),
                            this.isOpen ||
                                (e && e.stopPropagation
                                    ? (e.stopPropagation(),
                                      e.currentTarget.setAttribute("aria-expanded", "true"),
                                      (this.activeSource = e.currentTarget))
                                    : t && (t.setAttribute("aria-expanded", "true"), (this.activeSource = t)),
                                theme.utils.prepareTransition(
                                    this.drawer,
                                    function () {
                                        this.drawer.classList.add(this.config.activeDrawer);
                                    }.bind(this)
                                ),
                                document.documentElement.classList.add(this.config.openClass),
                                document.dispatchEvent(new CustomEvent('cart:build')),
                                (this.isOpen = !0),
                                theme.a11y.trapFocus({ container: this.drawer, namespace: "drawer_focus" }),
                                document.dispatchEvent(new CustomEvent("drawerOpen")),
                                document.dispatchEvent(new CustomEvent("drawerOpen." + this.config.id)),
                                this.bindEvents());
                    },
                    close: function (e) {
                        !this.isOpen ||
                            (e && !e.target.closest(".js-drawer-close") && e.target.closest(".drawer")) ||
                            (document.activeElement.blur(),
                            theme.utils.prepareTransition(
                                this.drawer,
                                function () {
                                    this.drawer.classList.remove(this.config.activeDrawer);
                                }.bind(this)
                            ),
                            document.documentElement.classList.remove(this.config.openClass),
                            document.documentElement.classList.add(this.config.closingClass),
                            window.setTimeout(
                                function () {
                                    document.documentElement.classList.remove(this.config.closingClass),
                                        this.activeSource &&
                                            this.activeSource.getAttribute("aria-expanded") &&
                                            (this.activeSource.setAttribute("aria-expanded", "false"),
                                            this.activeSource.focus());
                                }.bind(this),
                                500
                            ),
                            (this.isOpen = !1),
                            theme.a11y.removeTrapFocus({ container: this.drawer, namespace: "drawer_focus" }),
                            this.unbindEvents());
                    },
                    bindEvents: function () {
                        window.on(
                            "click" + this.config.namespace,
                            function (e) {
                                this.close(e);
                            }.bind(this)
                        ),
                            window.on(
                                "keyup" + this.config.namespace,
                                function (e) {
                                    27 === e.keyCode && this.close();
                                }.bind(this)
                            ),
                            theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
                    },
                    unbindEvents: function () {
                        window.off("click" + this.config.namespace),
                            window.off("keyup" + this.config.namespace),
                            theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
                    },
                })),
                Et)),
            (theme.Modals =
                ((V.prototype.init = function () {
                    document.querySelectorAll(this.config.open).forEach((e) => {
                        e.setAttribute("aria-expanded", "false"), e.addEventListener("click", this.open.bind(this));
                    }),
                        this.modal.querySelectorAll(this.config.close).forEach((e) => {
                            e.addEventListener("click", this.close.bind(this));
                        }),
                        document.addEventListener(
                            "drawerOpen",
                            function () {
                                this.close();
                            }.bind(this)
                        );
                }),
                (V.prototype.open = function (e) {
                    var t = !1;
                    this.modalIsOpen ||
                        (e ? e.preventDefault() : (t = !0),
                        e &&
                            e.stopPropagation &&
                            (e.stopPropagation(),
                            (this.activeSource = e.currentTarget.setAttribute("aria-expanded", "true"))),
                        this.modalIsOpen && !t && this.close(),
                        this.modal.classList.add(this.config.openClass),
                        document.documentElement.classList.add(...this.config.bodyOpenClass),
                        this.isSolid && document.documentElement.classList.add(this.config.bodyOpenSolidClass),
                        (this.modalIsOpen = !0),
                        setTimeout(() => {
                            theme.a11y.trapFocus({
                                container: this.modal,
                                elementToFocus: this.focusOnOpen,
                                namespace: "modal_focus",
                            });
                        }, 100),
                        document.dispatchEvent(new CustomEvent("modalOpen")),
                        document.dispatchEvent(new CustomEvent("modalOpen." + this.id)),
                        this.bindEvents());
                }),
                (V.prototype.close = function (e) {
                    !this.modalIsOpen ||
                        (e && !e.target.closest(".js-modal-close") && e.target.closest(".modal__inner")) ||
                        (document.activeElement.blur(),
                        this.modal.classList.remove(this.config.openClass),
                        this.modal.classList.add(this.config.closingClass),
                        document.documentElement.classList.remove(...this.config.bodyOpenClass),
                        document.documentElement.classList.add(this.config.bodyClosingClass),
                        window.setTimeout(
                            function () {
                                document.documentElement.classList.remove(this.config.bodyClosingClass),
                                    this.modal.classList.remove(this.config.closingClass),
                                    this.activeSource &&
                                        this.activeSource.getAttribute("aria-expanded") &&
                                        this.activeSource.setAttribute("aria-expanded", "false").focus();
                            }.bind(this),
                            500
                        ),
                        this.isSolid && document.documentElement.classList.remove(this.config.bodyOpenSolidClass),
                        (this.modalIsOpen = !1),
                        theme.a11y.removeTrapFocus({ container: this.modal, namespace: "modal_focus" }),
                        document.dispatchEvent(new CustomEvent("modalClose." + this.id)),
                        this.unbindEvents());
                }),
                (V.prototype.bindEvents = function () {
                    window.on(
                        "keyup.modal",
                        function (e) {
                            27 === e.keyCode && this.close();
                        }.bind(this)
                    ),
                        this.config.closeOffContentClick && this.modal.on("click.modal", this.close.bind(this));
                }),
                (V.prototype.unbindEvents = function () {
                    document.documentElement.off(".modal"),
                        this.config.closeOffContentClick && this.modal.off(".modal");
                }),
                V));
        class _t extends HTMLElement {
            constructor() {
                super(),
                    (this.parallaxImage = this.querySelector("[data-parallax-image]")),
                    (this.windowInnerHeight = window.innerHeight),
                    (this.isActive = !1),
                    (this.timeout = null),
                    (this.directionMap = { right: 0, top: 90, left: 180, bottom: 270 }),
                    (this.directionMultipliers = { 0: [1, 0], 90: [0, -1], 180: [-1, 0], 270: [0, 1] }),
                    this.init(),
                    window.addEventListener("scroll", () => this.scrollHandler());
            }
            getParallaxInfo() {
                var { width: e, height: t, top: i } = this.parallaxImage.getBoundingClientRect(),
                    s = this.parallaxImage;
                let n,
                    { angle: o, movement: a } = s.dataset,
                    r = "top" === o ? Math.ceil(t * (parseFloat(a) / 100)) : Math.ceil(e * (parseFloat(a) / 100));
                (o = this.directionMap[o] ?? parseFloat(o)) != o && (o = 270),
                    r != r && (r = 100),
                    (o %= 360) < 0 && (o += 360);
                var e = 90 < o && o < 270,
                    c = o < 180;
                return (
                    (s.style[e ? "left" : "right"] = 0),
                    (s.style[c ? "top" : "bottom"] = 0),
                    (n =
                        o % 90
                            ? ((e = (o * Math.PI) / 180), [Math.cos(e), -1 * Math.sin(e)])
                            : this.directionMultipliers[o])[0] &&
                        (s.style.width = `calc(100% + ${r * Math.abs(n[0])}px)`),
                    n[1] && (s.style.height = `calc(100% + ${r * Math.abs(n[1])}px)`),
                    { element: s, movementPixels: r, multipliers: n, top: i, height: t }
                );
            }
            init() {
                var { element: e, movementPixels: t, multipliers: i, top: s, height: n } = this.getParallaxInfo(),
                    s = (this.windowInnerHeight - s) / (this.windowInnerHeight + n);
                -0.1 < s &&
                    s < 1.1 &&
                    ((n = Math.min(Math.max(s, 0), 1) * t),
                    (e.style.transform = `translate3d(${n * i[0]}px, ${n * i[1]}px, 0)`)),
                    this.isActive && requestAnimationFrame(this.init.bind(this));
            }
            scrollHandler() {
                this.isActive
                    ? clearTimeout(this.timeout)
                    : ((this.isActive = !0), requestAnimationFrame(this.init.bind(this))),
                    (this.timeout = setTimeout(() => (this.isActive = !1), 20));
            }
        }
        if ((customElements.define("parallax-image", _t), void 0 === window.noUiSlider))
            throw new Error("theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js");
        function It(e, { onChange: t, onUpdate: i, ...s } = {}) {
            return (
                (this.container = e),
                (this.onChange = t),
                (this.onUpdate = i),
                (this.sliderOptions = s || {}),
                this.init()
            );
        }
        function kt(e, t, i) {
            (this.form = e),
                (this.args = i),
                this.form &&
                    ((this.addToCart = e.querySelector(t || ".add-to-cart")),
                    this.form.addEventListener("submit", this.addItemFromForm.bind(this)));
        }
        function Ct(e) {
            if (!e)
                if (window.ShopifyXR) {
                    for (var t in a) {
                        var i;
                        !a.hasOwnProperty(t) ||
                            (i = a[t]).loaded ||
                            ((t = document.querySelector("#ModelJson-" + t)),
                            window.ShopifyXR.addModels(JSON.parse(t.innerHTML)),
                            (i.loaded = !0));
                    }
                    window.ShopifyXR.setupXRElements();
                } else
                    document.addEventListener("shopify_xr_initialized", function () {
                        Ct();
                    });
        }
        function qt(e) {
            if (!e)
                for (var t in r)
                    r.hasOwnProperty(t) &&
                        (!(t = r[t]).modelViewerUi &&
                            Shopify &&
                            (t.modelViewerUi = new Shopify.ModelViewerUI(t.element)),
                        ((t) => {
                            var i = he[t.sectionId];
                            t.container.addEventListener("mediaVisible", function (e) {
                                i.element.setAttribute("data-shopify-model3d-id", t.modelId),
                                    theme.config.isTouch || (e.detail.autoplayMedia && t.modelViewerUi.play());
                            }),
                                t.container.addEventListener("mediaHidden", function () {
                                    i.element.setAttribute("data-shopify-model3d-id", i.defaultId),
                                        t.modelViewerUi.pause();
                                }),
                                t.container.addEventListener("xrLaunch", function () {
                                    t.modelViewerUi.pause();
                                });
                        })(t));
        }
        function At(e, t) {
            (this.wrapper = e),
                (this.plus = e.querySelector(ge)),
                (this.minus = e.querySelector(fe)),
                (this.input = e.querySelector(pe)),
                (this.minValue = this.input.getAttribute("min") || 1);
            e = { namespace: null, isCart: !1, key: this.input.dataset.id };
            (this.options = Object.assign({}, e, t)), this.init();
        }
        function xt(e, t) {
            if (
                ((this.el = e),
                (this.args = Object.assign({}, _e, t)),
                (this.args.on = {
                    ready: this.init.bind(this),
                    change: this.slideChange.bind(this),
                    settle: this.afterChange.bind(this),
                }),
                this.args.childNav &&
                    ((this.childNavEls = this.args.childNav.querySelectorAll(we)),
                    (this.childNavLinks = this.args.childNav.querySelectorAll(Le)),
                    (this.arrows = this.args.childNav.querySelectorAll(Ee)),
                    this.childNavLinks.length) &&
                    this.initChildNav(),
                this.args.avoidReflow)
            ) {
                t = e;
                if (t.id) {
                    for (var i = t.firstChild; null != i && 3 == i.nodeType; ) i = i.nextSibling;
                    var s = document.createElement("style");
                    (s.innerHTML = `#${t.id} .flickity-viewport{height:${i.offsetHeight}px}`),
                        document.head.appendChild(s);
                }
            }
            (this.slideshow = new Flickity(e, this.args)),
                e.dataset.zoom &&
                    "true" === e.dataset.zoom &&
                    (this.slideshow.on("dragStart", () => {
                        (this.slideshow.slider.style.pointerEvents = "none"),
                            this.slideshow.options.fade &&
                                (this.slideshow.slider.querySelector(".is-selected").style.pointerEvents = "none");
                    }),
                    this.slideshow.on("dragEnd", () => {
                        (this.slideshow.slider.style.pointerEvents = "auto"),
                            this.slideshow.options.fade &&
                                (this.slideshow.slider.querySelector(".is-selected").style.pointerEvents = "auto");
                    })),
                this.args.autoPlay &&
                    ((t = e.closest(Se)), (this.pauseBtn = t.querySelector(be)), this.pauseBtn) &&
                    this.pauseBtn.addEventListener("click", this._togglePause.bind(this)),
                window.on(
                    "resize",
                    theme.utils.debounce(
                        300,
                        function () {
                            this.resize();
                        }.bind(this)
                    )
                );
        }
        function Tt(e) {
            (this.type = e.type),
                (this.variantsObject = e.variantsObject),
                (this.currentVariantObject = e.currentVariantObject),
                (this.container = e.container),
                (this.namespace = e.namespace),
                this.init();
        }
        (theme.PriceRange =
            ((ae = ".price-range__slider"),
            (re = ".price-range__input-min"),
            (ce = ".price-range__input-max"),
            (de = ".price-range__display-min"),
            (le = ".price-range__display-max"),
            (It.prototype = Object.assign({}, It.prototype, {
                init: function () {
                    if (this.container.classList.contains("price-range"))
                        return (
                            (this.formEl = this.container.closest("form")),
                            (this.sliderEl = this.container.querySelector(ae)),
                            (this.inputMinEl = this.container.querySelector(re)),
                            (this.inputMaxEl = this.container.querySelector(ce)),
                            (this.displayMinEl = this.container.querySelector(de)),
                            (this.displayMaxEl = this.container.querySelector(le)),
                            (this.minRange = parseFloat(this.container.dataset.min) || 0),
                            (this.minValue = parseFloat(this.container.dataset.minValue) || 0),
                            (this.maxRange = parseFloat(this.container.dataset.max) || 100),
                            (this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange),
                            this.createPriceRange()
                        );
                    throw new Error("You must instantiate PriceRange with a valid container");
                },
                createPriceRange: function () {
                    this.sliderEl &&
                        this.sliderEl.noUiSlider &&
                        "function" == typeof this.sliderEl.noUiSlider.destroy &&
                        this.sliderEl.noUiSlider.destroy();
                    var e = noUiSlider.create(this.sliderEl, {
                        connect: !0,
                        step: 10,
                        ...this.sliderOptions,
                        start: [this.minValue, this.maxValue],
                        range: { min: this.minRange, max: this.maxRange },
                    });
                    return (
                        e.on("update", (e) => {
                            (this.displayMinEl.innerHTML = theme.Currency.formatMoney(
                                e[0],
                                theme.settings.moneyFormat
                            )),
                                (this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
                                    e[1],
                                    theme.settings.moneyFormat
                                )),
                                this.onUpdate && this.onUpdate(e);
                        }),
                        e.on("change", (e) => {
                            (this.inputMinEl.value = e[0]),
                                (this.inputMaxEl.value = e[1]),
                                this.onChange && ((e = new FormData(this.formEl)), this.onChange(e));
                        }),
                        e
                    );
                },
            })),
            It)),
            (theme.AjaxProduct =
                ((n = { loading: !1 }),
                (kt.prototype = Object.assign({}, kt.prototype, {
                    addItemFromForm: function (e, t) {
                        e.preventDefault(),
                            n.loading ||
                                (this.addToCart.classList.add("btn--loading"),
                                (n.loading = !0),
                                (e = theme.utils.serialize(this.form)),
                                fetch(theme.routes.cartAdd, {
                                    method: "POST",
                                    body: e,
                                    credentials: "same-origin",
                                    headers: {
                                        "Content-Type": "application/x-www-form-urlencoded",
                                        "X-Requested-With": "XMLHttpRequest",
                                    },
                                })
                                    .then((e) => e.json())
                                    .then(
                                        function (e) {
                                            422 === e.status ? this.error(e) : this.success(e),
                                                (n.loading = !1),
                                                this.addToCart.classList.remove("btn--loading"),
                                                document.body.classList.contains("template-cart") &&
                                                    (window.scrollTo(0, 0), location.reload());
                                        }.bind(this)
                                    ));
                    },
                    success: function (e) {
                        var t = this.form.querySelector(".errors");
                        t && t.remove(),
                            "page" === theme.settings.cartType && (window.location = theme.routes.cartPage),
                            this.form.dispatchEvent(
                                new CustomEvent("ajaxProduct:added", {
                                    detail: { product: e, addToCartBtn: this.addToCart },
                                    bubbles: !0,
                                })
                            ),
                            this.args &&
                                this.args.scopedEventId &&
                                document.dispatchEvent(
                                    new CustomEvent("ajaxProduct:added:" + this.args.scopedEventId, {
                                        detail: { product: e, addToCartBtn: this.addToCart },
                                    })
                                );
                    },
                    error: function (e) {
                        var t;
                        e.description
                            ? ((t = this.form.querySelector(".errors")) && t.remove(),
                              (t = document.createElement("div")).classList.add("errors", "text-center"),
                              "object" == typeof e.description
                                  ? (t.textContent = e.message)
                                  : (t.textContent = e.description),
                              this.form.append(t),
                              this.form.dispatchEvent(
                                  new CustomEvent("ajaxProduct:error", {
                                      detail: { errorMessage: e.description },
                                      bubbles: !0,
                                  })
                              ),
                              this.args &&
                                  this.args.scopedEventId &&
                                  document.dispatchEvent(
                                      new CustomEvent("ajaxProduct:error:" + this.args.scopedEventId, {
                                          detail: { errorMessage: e.description },
                                      })
                                  ))
                            : console.warn(e);
                    },
                })),
                kt)),
            (theme.ProductMedia =
                ((a = {}),
                (r = {}),
                (he = {}),
                (ue = "[data-product-single-media-group]"),
                (me = "[data-shopify-xr]"),
                {
                    init: function (e, o) {
                        (a[o] = { loaded: !1 }),
                            e.forEach(function (e, t) {
                                var i = e.dataset.mediaId,
                                    s = e.querySelector("model-viewer"),
                                    n = s.dataset.modelId;
                                0 === t &&
                                    ((t = e.closest(ue).querySelector(me)), (he[o] = { element: t, defaultId: n })),
                                    (r[i] = { modelId: n, sectionId: o, container: e, element: s });
                            }),
                            window.Shopify.loadFeatures([
                                { name: "shopify-xr", version: "1.0", onLoad: Ct },
                                { name: "model-viewer-ui", version: "1.0", onLoad: qt },
                            ]),
                            theme.LibraryLoader.load("modelViewerUiStyles");
                    },
                    removeSectionModels: function (e) {
                        for (var t in r) r.hasOwnProperty(t) && r[t].sectionId === e && delete r[t];
                        delete a[e];
                    },
                })),
            (theme.QtySelector =
                ((pe = ".js-qty__num"),
                (ge = ".js-qty__adjust--plus"),
                (fe = ".js-qty__adjust--minus"),
                (At.prototype = Object.assign({}, At.prototype, {
                    init: function () {
                        this.plus.addEventListener(
                            "click",
                            function () {
                                var e = this._getQty();
                                this._change(e + 1);
                            }.bind(this)
                        ),
                            this.minus.addEventListener(
                                "click",
                                function () {
                                    var e = this._getQty();
                                    this._change(e - 1);
                                }.bind(this)
                            ),
                            this.input.addEventListener(
                                "change",
                                function (e) {
                                    this._change(this._getQty());
                                }.bind(this)
                            );
                    },
                    _getQty: function () {
                        var e = this.input.value;
                        return (parseFloat(e) == parseInt(e) && !isNaN(e)) || (e = 1), parseInt(e);
                    },
                    _change: function (e) {
                        e <= this.minValue && (e = this.minValue),
                            (this.input.value = e),
                            this.options.isCart &&
                                document.dispatchEvent(
                                    new CustomEvent("cart:quantity" + this.options.namespace, {
                                        detail: [this.options.key, e, this.wrapper],
                                    })
                                );
                    },
                })),
                At)),
            (theme.initQuickShop = function () {
                var e = document.querySelectorAll(".grid-product");
                function s(e) {
                    var t,
                        i,
                        e = e.currentTarget;
                    theme.config.bpSmall ||
                        (e.removeEventListener("mouseover", s),
                        e.removeEventListener("focusin", s),
                        e &&
                            e.dataset.productId &&
                            ((t = e.dataset.productId),
                            (i = e.dataset.productHandle),
                            (e = e.querySelector(".quick-product__btn")),
                            theme.preloadProductModal(i, t, e)));
                }
                e.length &&
                    theme.settings.quickView &&
                    e.forEach((e) => {
                        e.addEventListener("mouseover", s), e.addEventListener("focusin", s);
                    });
            }),
            (theme.preloadProductModal = function (i, s, n) {
                var o = document.getElementById("QuickShopHolder-" + i),
                    e = (e = theme.routes.home + "/products/" + i + "?view=modal").replace("//", "/");
                fetch(e)
                    .then((e) => e.text())
                    .then((e) => {
                        var t = document.createElement("div"),
                            e =
                                ((t.innerHTML = e),
                                t.querySelector('.product-section[data-product-handle="' + i + '"]'));
                        o &&
                            ((o.innerHTML = ""),
                            o.append(e),
                            new theme.Modals("QuickShopModal-" + s, "quick-modal-" + s),
                            theme.sections.register("product", theme.Product, o),
                            theme.collapsibles.init(),
                            theme.videoModal(),
                            n) &&
                            n.classList.remove("quick-product__btn--not-ready");
                    });
            }),
            (theme.Slideshow =
                ((o = "animate-out"),
                (e = "is-paused"),
                (_e = {
                    adaptiveHeight: !(Ee = ".product__thumb-arrow"),
                    autoPlay: !(Le = ".product__thumb-item:not(.hide) a"),
                    avoidReflow: !(we = ".product__thumb-item:not(.hide)"),
                    childNav: null,
                    childNavScroller: null,
                    childVertical: !(be = ".slideshow__pause"),
                    dragThreshold: 7,
                    fade: !(Se = ".slideshow-wrapper"),
                    friction: 0.8,
                    initialIndex: 0,
                    pageDots: !(ve = ".is-selected"),
                    pauseAutoPlayOnHover: !(ye = ".slideshow__slide"),
                    prevNextButtons: !(m = "is-active"),
                    rightToLeft: theme.config.rtl,
                    selectedAttraction: 0.14,
                    setGallerySize: !0,
                    wrapAround: !0,
                }),
                (xt.prototype = Object.assign({}, xt.prototype, {
                    init: function (e) {
                        (this.currentSlide = this.el.querySelector(ve)),
                            this.args.callbacks &&
                                this.args.callbacks.onInit &&
                                "function" == typeof this.args.callbacks.onInit &&
                                this.args.callbacks.onInit(this.currentSlide),
                            window.AOS && AOS.refresh();
                    },
                    slideChange: function (e) {
                        this.args.fade &&
                            this.currentSlide &&
                            (this.currentSlide.classList.add(o),
                            this.currentSlide.addEventListener(
                                "transitionend",
                                function () {
                                    this.currentSlide.classList.remove(o);
                                }.bind(this)
                            )),
                            this.args.childNav && this.childNavGoTo(e),
                            this.args.callbacks &&
                                this.args.callbacks.onChange &&
                                "function" == typeof this.args.callbacks.onChange &&
                                this.args.callbacks.onChange(e),
                            this.arrows &&
                                this.arrows.length &&
                                (this.arrows[0].classList.toggle("hide", 0 === e),
                                this.arrows[1].classList.toggle("hide", e === this.childNavLinks.length - 1));
                    },
                    afterChange: function (e) {
                        this.args.fade &&
                            this.el.querySelectorAll(ye).forEach((e) => {
                                e.classList.remove(o);
                            }),
                            (this.currentSlide = this.el.querySelector(ve)),
                            this.args.childNav && this.childNavGoTo(this.slideshow.selectedIndex);
                    },
                    destroy: function () {
                        this.args.childNav &&
                            this.childNavLinks.length &&
                            this.childNavLinks.forEach((e) => {
                                e.classList.remove(m);
                            }),
                            this.slideshow.destroy();
                    },
                    reposition: function () {
                        this.slideshow.reposition();
                    },
                    _togglePause: function () {
                        this.pauseBtn.classList.contains(e)
                            ? (this.pauseBtn.classList.remove(e), this.slideshow.playPlayer())
                            : (this.pauseBtn.classList.add(e), this.slideshow.pausePlayer());
                    },
                    resize: function () {
                        this.slideshow.resize();
                    },
                    play: function () {
                        this.slideshow.playPlayer();
                    },
                    pause: function () {
                        this.slideshow.pausePlayer();
                    },
                    goToSlide: function (e) {
                        this.slideshow.select(e);
                    },
                    setDraggable: function (e) {
                        (this.slideshow.options.draggable = e), this.slideshow.updateDraggable();
                    },
                    initChildNav: function () {
                        this.childNavLinks[this.args.initialIndex].classList.add("is-active"),
                            this.childNavLinks.forEach((e, t) => {
                                e.setAttribute("data-index", t),
                                    e.addEventListener(
                                        "click",
                                        function (e) {
                                            e.preventDefault(), this.goToSlide(this.getChildIndex(e.currentTarget));
                                        }.bind(this)
                                    ),
                                    e.addEventListener(
                                        "focus",
                                        function (e) {
                                            this.goToSlide(this.getChildIndex(e.currentTarget));
                                        }.bind(this)
                                    ),
                                    e.addEventListener(
                                        "keydown",
                                        function (e) {
                                            13 === e.keyCode && this.goToSlide(this.getChildIndex(e.currentTarget));
                                        }.bind(this)
                                    );
                            }),
                            this.arrows.length &&
                                this.arrows.forEach((e) => {
                                    e.addEventListener("click", this.arrowClick.bind(this));
                                });
                    },
                    getChildIndex: function (e) {
                        return parseInt(e.dataset.index);
                    },
                    childNavGoTo: function (e) {
                        this.childNavLinks.forEach((e) => {
                            e.blur(), e.classList.remove(m);
                        });
                        var t,
                            e = this.childNavLinks[e];
                        e.classList.add(m),
                            this.args.childNavScroller &&
                                (this.args.childVertical
                                    ? ((t = e.offsetTop), (this.args.childNavScroller.scrollTop = t - 100))
                                    : ((t = e.offsetLeft), (this.args.childNavScroller.scrollLeft = t - 100)));
                    },
                    arrowClick: function (e) {
                        e.currentTarget.classList.contains("product__thumb-arrow--prev")
                            ? this.slideshow.previous()
                            : this.slideshow.next();
                    },
                })),
                xt)),
            (theme.VariantAvailability =
                ((p = "disabled"),
                (Tt.prototype = Object.assign({}, Tt.prototype, {
                    init: function () {
                        this.container.on("variantChange" + this.namespace, this.setAvailability.bind(this)),
                            this.setInitialAvailability();
                    },
                    createAvailableOptionsTree(e, a) {
                        return e.reduce(
                            (n, o) => (
                                Object.keys(n).forEach((t) => {
                                    if (null !== o[t]) {
                                        let e = n[t].find((e) => e.value === o[t]);
                                        void 0 === e && ((e = { value: o[t], soldOut: !0 }), n[t].push(e));
                                        var i = a.find(({ index: e }) => "option1" === e),
                                            s = a.find(({ index: e }) => "option2" === e);
                                        switch (t) {
                                            case "option1":
                                                e.soldOut = (!e.soldOut || !o.available) && e.soldOut;
                                                break;
                                            case "option2":
                                                i &&
                                                    o.option1 === i.value &&
                                                    (e.soldOut = (!e.soldOut || !o.available) && e.soldOut);
                                            case "option3":
                                                i &&
                                                    o.option1 === i.value &&
                                                    s &&
                                                    o.option2 === s.value &&
                                                    (e.soldOut = (!e.soldOut || !o.available) && e.soldOut);
                                        }
                                    }
                                }),
                                n
                            ),
                            { option1: [], option2: [], option3: [] }
                        );
                    },
                    setInitialAvailability: function () {
                        this.container.querySelectorAll(".variant-input-wrap").forEach((e) => {
                            this.disableVariantGroup(e);
                        });
                        var e,
                            t,
                            i = this.currentVariantObject.options.map((e, t) => ({
                                value: e,
                                index: "option" + (t + 1),
                            })),
                            i = this.createAvailableOptionsTree(this.variantsObject, i, this.currentVariantObject);
                        for ([e, t] of Object.entries(i)) this.manageOptionState(e, t);
                    },
                    setAvailability: function (e) {
                        var t,
                            i,
                            { value: s, index: e, currentlySelectedValues: n, variant: o } = e.detail,
                            n = this.createAvailableOptionsTree(this.variantsObject, n, o, e, s);
                        for ([t, i] of Object.entries(n)) this.manageOptionState(t, i, s);
                    },
                    manageOptionState: function (e, t) {
                        var i = this.container.querySelector('.variant-input-wrap[data-index="' + e + '"]');
                        t.forEach((e) => {
                            this.enableVariantOption(i, e);
                        });
                    },
                    enableVariantOption: function (e, t) {
                        var i = t.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1");
                        "dropdown" === this.type
                            ? t.soldOut
                                ? (e.querySelector('option[value="' + i + '"]').disabled = !0)
                                : (e.querySelector('option[value="' + i + '"]').disabled = !1)
                            : ((i = (e = e.querySelector('.variant-input[data-value="' + i + '"]')).querySelector(
                                  "input"
                              )),
                              (e = e.querySelector("label")),
                              i.classList.remove(p),
                              e.classList.remove(p),
                              t.soldOut && (i.classList.add(p), e.classList.add(p)));
                    },
                    disableVariantGroup: function (e) {
                        "dropdown" === this.type
                            ? e.querySelectorAll("option").forEach((e) => {
                                  e.disabled = !0;
                              })
                            : (e.querySelectorAll("input").forEach((e) => {
                                  e.classList.add(p);
                              }),
                              e.querySelectorAll("label").forEach((e) => {
                                  e.classList.add(p);
                              }));
                    },
                })),
                Tt)),
            (theme.videoModal = function () {
                var t,
                    i,
                    s,
                    n,
                    o = "VideoHolder",
                    e = 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
                    a = 'a[href*="player.vimeo.com/player/"], a[href*="vimeo.com/"]',
                    r = ".product-video-trigger--mp4",
                    c = ".product-video-mp4-sound",
                    e = document.querySelectorAll(e),
                    a = document.querySelectorAll(a),
                    r = document.querySelectorAll(r);
                function d(e) {
                    theme.config.youTubeReady &&
                        (e.preventDefault(),
                        m(),
                        n.open(e),
                        (e = ((e) =>
                            !(
                                !(e = e.match(
                                    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
                                )) || 11 != e[7].length
                            ) && e[7])(e.currentTarget.getAttribute("href"))),
                        (t = new theme.YouTube(o, { videoId: e, style: "sound", events: { onReady: u } })));
                }
                function l(e) {
                    var t;
                    theme.config.vimeoReady &&
                        (e.preventDefault(),
                        m(),
                        n.open(e),
                        (t = e.currentTarget.dataset.videoId),
                        (e = e.currentTarget.dataset.videoLoop),
                        (i = new theme.VimeoPlayer(o, t, { style: "sound", loop: e })));
                }
                function h(e) {
                    m();
                    var t = e.currentTarget.parentNode.querySelector(c).cloneNode(!0);
                    t.classList.remove("hide"), s.append(t), n.open(e), s.querySelector("video").play();
                }
                function u(e) {
                    e.target.unMute(), e.target.playVideo();
                }
                function m() {
                    s.innerHTML = "";
                }
                (e.length || a.length || r.length) &&
                    ((s = document.getElementById(o)),
                    e.length && theme.LibraryLoader.load("youtubeSdk"),
                    a.length && theme.LibraryLoader.load("vimeo", window.vimeoApiReady),
                    (n = new theme.Modals("VideoModal", "video-modal", {
                        closeOffContentClick: !0,
                        bodyOpenClass: ["modal-open", "video-modal-open"],
                        solid: !0,
                    })),
                    e.forEach((e) => {
                        e.addEventListener("click", d);
                    }),
                    a.forEach((e) => {
                        e.addEventListener("click", l);
                    }),
                    r.forEach((e) => {
                        e.addEventListener("click", h);
                    }),
                    document.addEventListener("modalClose.VideoModal", function () {
                        t && "function" == typeof t.destroy
                            ? t.destroy()
                            : i && "function" == typeof i.destroy
                              ? i.destroy()
                              : m();
                    }));
            });
        class Ot extends HTMLElement {
            constructor() {
                super(),
                    ((this.el = this).inner = this.querySelector("[data-tool-tip-inner]")),
                    (this.closeButton = this.querySelector("[data-tool-tip-close]")),
                    (this.toolTipContent = this.querySelector("[data-tool-tip-content]")),
                    (this.toolTipTitle = this.querySelector("[data-tool-tip-title]")),
                    (this.triggers = document.querySelectorAll("[data-tool-tip-trigger]")),
                    document.addEventListener("tooltip:open", (e) => {
                        this._open(e.detail.context, e.detail.content);
                    });
            }
            _open(e, t) {
                (this.toolTipContent.innerHTML = t),
                    "store-availability" != e && this.toolTipTitle.remove(),
                    this._lockScrolling(),
                    this.closeButton &&
                        this.closeButton.on("click.tooltip-close", () => {
                            this._close();
                        }),
                    document.documentElement.on("click.tooltip-outerclick", (e) => {
                        "true" !== this.el.dataset.toolTipOpen || this.inner.contains(e.target) || this._close();
                    }),
                    document.documentElement.on("keydown.tooltip-esc", (e) => {
                        "Escape" === e.code && this._close();
                    }),
                    (this.el.dataset.toolTipOpen = !0),
                    (this.el.dataset.toolTip = e);
            }
            _close() {
                (this.toolTipContent.innerHTML = ""),
                    (this.el.dataset.toolTipOpen = "false"),
                    (this.el.dataset.toolTip = ""),
                    this._unlockScrolling(),
                    this.closeButton.off("click.tooltip-close"),
                    document.documentElement.off("click.tooltip-outerclick"),
                    document.documentElement.off("keydown.tooltip-esc");
            }
            _lockScrolling() {
                theme.a11y.trapFocus({ container: this.el, namespace: "tooltip_focus" }),
                    theme.a11y.lockMobileScrolling(),
                    document.documentElement.classList.add("modal-open");
            }
            _unlockScrolling() {
                theme.a11y.removeTrapFocus({ container: this.el, namespace: "tooltip_focus" }),
                    theme.a11y.unlockMobileScrolling(),
                    document.documentElement.classList.remove("modal-open");
            }
        }
        customElements.define("tool-tip", Ot);
        class Pt extends HTMLElement {
            constructor() {
                super(), ((this.el = this).toolTipContent = this.querySelector("[data-tool-tip-content]")), this.init();
            }
            init() {
                let t = new CustomEvent("tooltip:open", {
                    detail: { context: this.dataset.toolTip, content: this.toolTipContent.innerHTML },
                    bubbles: !0,
                });
                this.el.addEventListener("click", (e) => {
                    e.stopPropagation(), this.dispatchEvent(t);
                });
            }
        }
        customElements.define("tool-tip-trigger", Pt);
        class Mt extends HTMLElement {
            constructor() {
                super(),
                    (this.closeBtn = this.querySelector("[data-close-button]")),
                    (this.popupTrigger = this.querySelector("[data-message]")),
                    (this.id = this.dataset.sectionId),
                    (this.newsletterId = "NewsletterPopup-" + this.id),
                    (this.cookie = Cookies.get("newsletter-" + this.id)),
                    (this.cookieName = "newsletter-" + this.id),
                    (this.secondsBeforeShow = this.dataset.delaySeconds),
                    (this.expiry = parseInt(this.dataset.delayDays)),
                    (this.modal = new theme.Modals("NewsletterPopup-" + this.newsletterId, "newsletter-popup-modal")),
                    this.init();
            }
            init() {
                document.addEventListener("shopify:block:select", (e) => {
                    e.detail.sectionId === this.id && this.show(0, !0);
                }),
                    document.addEventListener("shopify:block:deselect", (e) => {
                        e.detail.sectionId === this.id && this.hide();
                    }),
                    document.addEventListener("modalOpen." + this.newsletterId, () => this.hide()),
                    document.addEventListener("modalClose." + this.newsletterId, () => this.show()),
                    document.addEventListener("newsletter:openReminder", () => this.show(0)),
                    this.closeBtn.addEventListener("click", () => {
                        this.hide(), Cookies.set(this.cookieName, "opened", { path: "/", expires: this.expiry });
                    }),
                    this.popupTrigger.addEventListener("click", () => {
                        var e = new CustomEvent("reminder:openNewsletter", { bubbles: !0 });
                        this.dispatchEvent(e), this.hide();
                    });
            }
            show(e = this.secondsBeforeShow, t) {
                "true" !== sessionStorage.getItem("reminderAppeared") &&
                    setTimeout(() => {
                        (this.dataset.enabled = "true"), sessionStorage.setItem("reminderAppeared", !0);
                    }, 1e3 * e);
            }
            hide() {
                this.dataset.enabled = "false";
            }
        }
        customElements.define("newsletter-reminder", Mt);
        class Vt extends HTMLElement {
            constructor() {
                super(), this.init();
            }
            init() {
                new IntersectionObserver(
                    ((e, t) => {
                        e[0].isIntersecting && (this.removeAnimations(), t.unobserve(this));
                    }).bind(this),
                    { rootMargin: "0px 0px 400px 0px" }
                ).observe(this);
            }
            removeAnimations() {
                var e = this.closest(".image-wrap"),
                    t = this.closest(".skrim__link");
                e && e.classList.add("loaded"), t && t.classList.add("loaded");
            }
        }
        customElements.define("image-element", Vt);
        class Ht extends HTMLElement {
            constructor() {
                super(),
                    (this.enabled = this.getAttribute("data-enabled")),
                    (this.context = this.getAttribute("data-context")),
                    (this.input = this.querySelector('input[type="search"]')),
                    (this.predictiveSearchResults = this.querySelector("#predictive-search")),
                    (this.closeBtn = this.querySelector(".btn--close-search")),
                    (this.screen = this.querySelector("[data-screen]")),
                    (this.SearchModal = this.closest("#SearchModal") || null),
                    document.addEventListener("predictive-search:open", (e) => {
                        e.detail.context === this.context &&
                            (this.classList.add("is-active"),
                            setTimeout(() => {
                                this.input.focus();
                            }, 100),
                            document.body.classList.add("predictive-overflow-hidden"));
                    }),
                    this.SearchModal &&
                        new MutationObserver((e) => {
                            e.forEach((e) => {
                                "class" === e.attributeName &&
                                    -1 < e.target.className.indexOf("modal--is-active") &&
                                    setTimeout(() => {
                                        this.input.focus();
                                    }, 100);
                            });
                        }).observe(this.SearchModal, { attributes: !0 }),
                    "false" !== this.enabled &&
                        (this.input.addEventListener("keydown", () => {
                            this.classList.add("is-active");
                        }),
                        this.input.addEventListener(
                            "input",
                            this.debounce((e) => {
                                this.onChange(e);
                            }, 300).bind(this)
                        ),
                        document.addEventListener("predictive-search:close", () => {
                            this.close();
                        }),
                        document.addEventListener("keydown", (e) => {
                            27 === e.keyCode && this.close();
                        }),
                        this.closeBtn.addEventListener("click", (e) => {
                            e.preventDefault(), this.close();
                        }),
                        this.screen.addEventListener("click", () => {
                            this.close();
                        }));
            }
            onChange() {
                var e = this.input.value.trim();
                e.length && this.getSearchResults(e);
            }
            getSearchResults(e) {
                e = this.paramUrl({
                    q: e,
                    "resources[limit]": 3,
                    "resources[limit_scope]": "each",
                    "resources[options][unavailable_products]": "last",
                });
                fetch(theme.routes.predictiveSearch + `?${e}&section_id=search-results`)
                    .then((e) => {
                        if (e.ok) return e.text();
                        throw ((e = new Error(e.status)), this.close(), e);
                    })
                    .then((e) => {
                        e = new DOMParser()
                            .parseFromString(e, "text/html")
                            .querySelector("#shopify-section-search-results").innerHTML;
                        (this.predictiveSearchResults.innerHTML = e), this.open(), AOS.refreshHard();
                    })
                    .catch((e) => {
                        throw (this.close(), e);
                    });
            }
            open() {
                this.predictiveSearchResults.style.display = "block";
            }
            close() {
                (this.predictiveSearchResults.style.display = "none"),
                    (this.predictiveSearchResults.innerHTML = ""),
                    this.classList.remove("is-active"),
                    document.body.classList.remove("predictive-overflow-hidden"),
                    document.dispatchEvent(new CustomEvent("predictive-search:close-all"));
            }
            debounce(t, i) {
                let s;
                return (...e) => {
                    clearTimeout(s), (s = setTimeout(() => t.apply(this, e), i));
                };
            }
            paramUrl(t) {
                return Object.keys(t)
                    .map(function (e) {
                        return e + "=" + encodeURIComponent(t[e]);
                    })
                    .join("&");
            }
        }
        customElements.define("predictive-search", Ht);
        class Dt extends HTMLElement {
            constructor() {
                super(),
                    (this.checkboxInput = this.querySelector("#Recipient-Checkbox-" + this.dataset.sectionId)),
                    (this.emailInput = this.querySelector("#Recipient-email-" + this.dataset.sectionId)),
                    (this.nameInput = this.querySelector("#Recipient-name-" + this.dataset.sectionId)),
                    (this.messageInput = this.querySelector("#Recipient-message-" + this.dataset.sectionId)),
                    (this.dateInput = this.querySelector("#Recipient-send-on-" + this.dataset.sectionId)),
                    this.addEventListener("change", () => this.onChange()),
                    (this.recipientFields = this.querySelector(".recipient-fields")),
                    this.checkboxInput.addEventListener("change", () => {
                        this.recipientFields.style.display = this.checkboxInput.checked ? "block" : "none";
                    });
            }
            connectedCallback() {
                document.addEventListener("ajaxProduct:error", (e) => {
                    e.target.querySelector('[name="id"]').value === this.dataset.productVariantId &&
                        this.displayErrorMessage(e.detail.errorMessage);
                }),
                    document.addEventListener("ajaxProduct:added", (e) => {
                        e.target.querySelector('[name="id"]').value === this.dataset.productVariantId &&
                            (this.clearInputFields(), this.clearErrorMessage());
                    });
            }
            onChange() {
                this.checkboxInput.checked || (this.clearInputFields(), this.clearErrorMessage());
            }
            clearInputFields() {
                this.querySelectorAll(".field__input").forEach((e) => (e.value = ""));
            }
            displayErrorMessage(e) {
                if ((this.clearErrorMessage(), e))
                    return Object.entries(e).forEach(([e]) => {
                        e = this[e + "Input"];
                        e && (e.setAttribute("aria-invalid", !0), e.classList.add("field__input--error"));
                    });
            }
            clearErrorMessage() {
                this.querySelectorAll(".field__input").forEach((e) => {
                    e.setAttribute("aria-invalid", !1),
                        e.removeAttribute("aria-describedby"),
                        e.classList.remove("field__input--error");
                });
            }
        }
        function Ft() {
            f = new theme.Slideshow(g, Ie);
        }
        function jt() {
            f && "function" == typeof f.destroy && f.destroy();
        }
        function Bt() {
            (this.form = document.querySelector(ke)),
                (this.drawer = new theme.Drawers("CartDrawer", "cart")),
                this.init();
        }
        function Rt() {
            var e;
            b.stickyEnabled &&
                ((e = v.offsetHeight),
                v.classList.contains("site-header--stuck") &&
                    !theme.config.bpSmall &&
                    (e += 2 * parseFloat(window.getComputedStyle(v, null).getPropertyValue("padding-top"))),
                (document.querySelector("#" + b.stickyHeaderWrapper).style.height = e + "px"));
        }
        function Nt() {
            !b.stickyEnabled || b.forceStopSticky || (requestAnimationFrame(Ut), (b.lastScroll = window.scrollY));
        }
        function Ut() {
            250 < window.scrollY
                ? b.stickyActive ||
                  ((b.stickyActive = !0),
                  v.classList.add(b.stickyClass),
                  b.wrapperOverlayed && y.classList.remove(b.overlayedClass),
                  setTimeout(function () {
                      v.classList.add(b.openTransitionClass);
                  }, 100))
                : b.stickyActive &&
                  ((b.stickyActive = !1),
                  v.classList.remove(b.openTransitionClass),
                  v.classList.remove(b.stickyClass),
                  b.wrapperOverlayed) &&
                  y.classList.add(b.overlayedClass);
        }
        customElements.define("recipient-form", Dt),
            (theme.announcementBar =
                ((Ie = { autoPlay: 5e3, avoidReflow: !0, cellAlign: theme.config.rtl ? "right" : "left" }),
                {
                    init: function () {
                        (g = document.getElementById("AnnouncementSlider")) &&
                            (jt(), 1 !== g.dataset.blockCount) &&
                            ((!theme.config.bpSmall && "true" !== g.dataset.compact) || Ft(),
                            document.addEventListener("matchSmall", function () {
                                jt(), Ft();
                            }),
                            document.addEventListener("unmatchSmall", function () {
                                jt(), "true" === g.dataset.compact && Ft();
                            }));
                    },
                    onBlockSelect: function (e) {
                        (e = g.querySelector("#AnnouncementSlide-" + e)),
                            (e = parseInt(e.dataset.index)),
                            f && "function" == typeof f.pause && (f.goToSlide(e), f.pause());
                    },
                    onBlockDeselect: function () {
                        f && "function" == typeof f.play && f.play();
                    },
                    unload: jt,
                })),
            (theme.customerTemplates = function () {
                "#recover" === window.location.hash && i();
                var t,
                    e = document.getElementById("RecoverPassword");
                function i() {
                    document.getElementById("RecoverPasswordForm").classList.toggle("hide"),
                        document.getElementById("CustomerLoginForm").classList.toggle("hide");
                }
                e &&
                    e.addEventListener("click", function (e) {
                        e.preventDefault(), i();
                    }),
                    (e = document.getElementById("HideRecoverPasswordLink")) &&
                        e.addEventListener("click", function (e) {
                            e.preventDefault(), i();
                        }),
                    document.querySelector(".reset-password-success") &&
                        document.getElementById("ResetSuccess").classList.remove("hide"),
                    (t = document.getElementById("AddressNewForm")),
                    (e = document.querySelectorAll(".js-address-form")),
                    t &&
                        e.length &&
                        (setTimeout(function () {
                            document.querySelectorAll(".js-address-country").forEach((e) => {
                                var t = e.dataset.countryId,
                                    i = e.dataset.provinceId,
                                    e = e.dataset.provinceContainerId;
                                new Shopify.CountryProvinceSelector(t, i, { hideElement: e });
                            });
                        }, 1e3),
                        document.querySelectorAll(".address-new-toggle").forEach((e) => {
                            e.addEventListener("click", function () {
                                t.classList.toggle("hide");
                            });
                        }),
                        document.querySelectorAll(".address-edit-toggle").forEach((e) => {
                            e.addEventListener("click", function (e) {
                                e = e.currentTarget.dataset.formId;
                                document.getElementById("EditAddress_" + e).classList.toggle("hide");
                            });
                        }),
                        document.querySelectorAll(".address-delete").forEach((e) => {
                            e.addEventListener("click", function (e) {
                                var t = e.currentTarget.dataset.formId,
                                    e = e.currentTarget.dataset.confirmMessage;
                                confirm(e || "Are you sure you wish to delete this address?") &&
                                    Shopify &&
                                    Shopify.postLink("/account/addresses/" + t, { parameters: { _method: "delete" } });
                            });
                        }));
            }),
            (theme.CartDrawer =
                ((ke = "#CartDrawerForm"),
                (Bt.prototype = Object.assign({}, Bt.prototype, {
                    init: function () {
                        (this.cartForm = new theme.CartForm(this.form)),
                            this.cartForm.buildCart(),
                            document.addEventListener(
                                "ajaxProduct:added",
                                function (e) {
                                    this.cartForm.buildCart(), this.open();
                                }.bind(this)
                            ),
                            document.addEventListener("cart:open", this.open.bind(this)),
                            document.addEventListener("cart:close", this.close.bind(this));
                    },
                    open: function () {
                        this.drawer.open(),
                            theme.a11y.trapFocus({
                                container: this.form,
                                elementToFocus: this.form,
                                namespace: "cartdrawer_focus",
                            });
                    },
                    close: function () {
                        this.drawer.close(),
                            theme.a11y.removeTrapFocus({ container: this.form, namespace: "cartdrawer_focus" });
                    },
                })),
                Bt)),
            (theme.headerNav =
                ((b = {
                    namespace: ".siteNav",
                    wrapperOverlayed: !(S = {
                        wrapper: "#HeaderWrapper",
                        siteHeader: "#SiteHeader",
                        searchBtn: ".js-search-header",
                        closeSearch: "#SearchClose",
                        searchContainer: ".site-header__search-container",
                        logo: "#LogoContainer img",
                        megamenu: ".megamenu",
                        navItems: ".site-nav__item",
                        navLinks: ".site-nav__link",
                        navLinksWithDropdown: ".site-nav__link--has-dropdown",
                        navDropdownLinks: ".site-nav__dropdown-link--second-level",
                        navDetails: ".site-nav__details",
                    }),
                    overlayedClass: "is-light",
                    overlayEnabledClass: "header-wrapper--sticky",
                    stickyEnabled: !1,
                    stickyActive: !1,
                    stickyClass: "site-header--stuck",
                    stickyHeaderWrapper: "StickyHeaderWrap",
                    openTransitionClass: "site-header--opening",
                    lastScroll: 0,
                }),
                {
                    init: function () {
                        if (
                            ((y = document.querySelector(S.wrapper)),
                            (v = document.querySelector(S.siteHeader)),
                            (b.stickyEnabled = "true" === v.dataset.sticky),
                            b.stickyEnabled)
                        )
                            if (
                                ((b.wrapperOverlayed = y.classList.contains(b.overlayedClass)),
                                (theme.config.stickyHeader = (() => {
                                    var t = 0;
                                    return (
                                        v.querySelectorAll(S.megamenu).forEach((e) => {
                                            e = e.offsetHeight;
                                            t < e && (t = e);
                                        }),
                                        !(window.innerHeight < t + 120)
                                    );
                                })()),
                                theme.config.stickyHeader)
                            ) {
                                (b.forceStopSticky = !1), (b.lastScroll = 0);
                                var e = document.createElement("div");
                                (e.id = b.stickyHeaderWrapper),
                                    theme.utils.wrap(v, e),
                                    (e = (e = (e = v).closest(".shopify-section-group-header-group"))
                                        .nextElementSibling) &&
                                        e.classList.contains("shopify-section-group-header-group") &&
                                        ((e = e.offsetHeight),
                                        (document.querySelector(S.wrapper).style.top = e + "px")),
                                    Rt(),
                                    window.on("resize" + b.namespace, theme.utils.debounce(50, Rt)),
                                    window.on("scroll" + b.namespace, theme.utils.throttle(20, Nt)),
                                    Shopify &&
                                        Shopify.designMode &&
                                        setTimeout(function () {
                                            Rt();
                                        }, 250);
                            } else b.forceStopSticky = !0;
                        (theme.settings.overlayHeader = "true" === v.dataset.overlay),
                            theme.settings.overlayHeader &&
                                Shopify &&
                                Shopify.designMode &&
                                document.body.classList.contains("template-collection") &&
                                !document.querySelector(".collection-hero") &&
                                this.disableOverlayHeader(),
                            document.querySelectorAll(S.navDetails).forEach((t) => {
                                let i = t.querySelector("summary");
                                document.addEventListener("click", (e) => {
                                    t.hasAttribute("open") && !t.contains(e.target)
                                        ? (t.removeAttribute("open"), i.setAttribute("aria-expanded", "false"))
                                        : t.hasAttribute("open")
                                          ? i.setAttribute("aria-expanded", "false")
                                          : i.setAttribute("aria-expanded", "true");
                                });
                            }),
                            document.querySelectorAll(S.searchBtn).forEach((e) => {
                                e.addEventListener("click", function (e) {
                                    e.preventDefault(),
                                        e.stopPropagation(),
                                        document.dispatchEvent(
                                            new CustomEvent("predictive-search:open", {
                                                detail: { context: "header" },
                                                bubbles: !0,
                                            })
                                        ),
                                        document.querySelector(S.searchContainer).classList.add("is-active");
                                });
                            }),
                            document.addEventListener("predictive-search:close-all", function () {
                                !(function (e) {
                                    if (e)
                                        for (
                                            var t = e.path || (e.composedPath && e.composedPath()), i = 0;
                                            i < t.length;
                                            i++
                                        )
                                            if (t[i].classList) {
                                                if (t[i].classList.contains("site-header__search-btn")) break;
                                                if (t[i].classList.contains("site-header__search-container")) return;
                                            }
                                    document.activeElement.blur(),
                                        document.documentElement.classList.add("js-drawer-closing"),
                                        document.documentElement.classList.remove(
                                            "js-drawer-open",
                                            "js-drawer-open--search"
                                        ),
                                        window.setTimeout(
                                            function () {
                                                document.documentElement.classList.remove("js-drawer-closing");
                                            }.bind(this),
                                            500
                                        );
                                    var s = document.querySelector(S.searchContainer);
                                    theme.utils.prepareTransition(
                                        s,
                                        function () {
                                            s.classList.remove("is-active");
                                        }.bind(this)
                                    );
                                })();
                            });
                    },
                    disableOverlayHeader: function () {
                        y.classList.remove(b.overlayEnabledClass, b.overlayedClass),
                            (b.wrapperOverlayed = !1),
                            (theme.settings.overlayHeader = !1);
                    },
                })),
            (window.onpageshow = function (e) {
                e.persisted &&
                    (document.body.classList.remove("unloading"),
                    document.querySelectorAll(".cart__checkout").forEach((e) => {
                        e.classList.remove("btn--loading");
                    }));
            }),
            (theme.buildProductGridItem = function (e, n, o, a) {
                var r = "";
                return (
                    e.forEach((e) => {
                        let t = theme.buildProductImage(e, a),
                            i = "",
                            s = "";
                        theme.settings.predictiveSearchPrice &&
                            (i = `<div class="grid-product__price">${theme.strings.productFrom}${theme.Currency.formatMoney(e.price_min, theme.moneyFormat)}</div>`),
                            theme.settings.predictiveSearchVendor &&
                                (s = `<div class="grid-product__vendor">${e.vendor}</div>`);
                        e = `
<div class="grid__item grid-product ${n} aos-animate" data-aos="row-of-${o}">
          <div class="grid-product__content">
            <a href="${e.url}" class="grid-product__link">
              <div class="grid-product__image-mask">
                ${t}
              </div>
                <div class="grid-product__meta">
                <div class="grid-product__title">${e.title}</div>
                  <div class='jdgm-badge-placeholder' data-handle='${e.handle}'></div>
                <div class="judgeme-badge-placeholder" data-id="${id}"></div>
                <span class="grid-product__price--original grid-product__price">₹${(e.compare_at_price / 100).toFixed(2)} </span>
                <span class="grid-product__price">₹${(e.price / 100).toFixed(2)} </span>
        
                <span class="grid-product__price--savings" style="color:#BE5B5B;">
                    ${e.compare_at_price > 0 ? Math.round(((e.compare_at_price - e.price) / e.compare_at_price) * 100) + "% off" : ""}
                </span>
              </div>
            </a>
          </div>
        </div>
      `;
                        r += e;
                    }),
                    r
                );
            }),
            (theme.buildProductImage = function (i, e) {
                var t,
                    s,
                    n = theme.settings.productImageSize;
                function o(e, t) {
                    (e.src = i.image_responsive_url),
                        (e.srcset = i.image_responsive_urls.toString()),
                        (e.alt = i.title),
                        (e.sizes = t);
                }
                return (
                    "natural" === n
                        ? ((s = (t = document.getElementById("naturalImageMarkup").content.cloneNode(!0)).querySelector(
                              "img"
                          )),
                          (t.querySelector(".image-wrap").style.paddingBottom = i.image_aspect_ratio + "%"),
                          o(s, e),
                          (s = document.createElement("div")).appendChild(t),
                          s)
                        : ((s = (t = document
                              .getElementById("fixedRatioImageMarkup")
                              .content.cloneNode(!0)).querySelector("img")),
                          t.querySelector(".grid__image-ratio").classList.add("grid__image-ratio--" + n),
                          theme.settings.productImageCover || s.classList.add("grid__image-contain"),
                          o(s, e),
                          (n = document.createElement("div")).appendChild(t),
                          n)
                ).innerHTML;
            });
        class zt extends HTMLElement {
            constructor() {
                super(),
                    (this.cookieName = this.id),
                    (this.cookie = Cookies.get(this.cookieName)),
                    (this.classes = {
                        activeContent: "age-verification-popup__content--active",
                        inactiveContent: "age-verification-popup__content--inactive",
                        inactiveDeclineContent: "age-verification-popup__decline-content--inactive",
                        activeDeclineContent: "age-verification-popup__decline-content--active",
                    }),
                    (this.declineButton = this.querySelector("[data-age-verification-popup-decline-button]")),
                    (this.declineContent = this.querySelector("[data-age-verification-popup-decline-content]")),
                    (this.content = this.querySelector("[data-age-verification-popup-content]")),
                    (this.returnButton = this.querySelector("[data-age-verification-popup-return-button]")),
                    (this.exitButton = this.querySelector("[data-age-verification-popup-exit-button]")),
                    (this.backgroundImage = this.querySelector("[data-background-image]")),
                    (this.mobileBackgroundImage = this.querySelector("[data-mobile-background-image]")),
                    Shopify.designMode &&
                        (document.addEventListener("shopify:section:select", (e) => {
                            e.detail.sectionId === this.dataset.sectionId && this.init();
                        }),
                        document.addEventListener("shopify:section:load", (e) => {
                            e.detail.sectionId === this.dataset.sectionId &&
                                (this.init(),
                                "true" === this.dataset.testMode && this.cookie && Cookies.remove(this.cookieName),
                                sessionStorage.getItem(this.id)) &&
                                this.showDeclineContent();
                        }),
                        document.addEventListener("shopify:section:unload", (e) => {
                            e.detail.sectionId === this.dataset.sectionId && this.modal.close();
                        })),
                    (this.cookie && "false" === this.dataset.testMode) || this.init();
            }
            init() {
                (this.modal = new theme.Modals(this.id, "age-verification-popup-modal", { closeOffContentClick: !1 })),
                    this.backgroundImage && (this.backgroundImage.style.display = "block"),
                    theme.config.bpSmall &&
                        this.mobileBackgroundImage &&
                        (this.mobileBackgroundImage.style.display = "block"),
                    this.modal.open(),
                    theme.a11y.lockMobileScrolling("#" + this.id, document.querySelector("#MainContent")),
                    this.declineButton &&
                        this.declineButton.addEventListener("click", (e) => {
                            e.preventDefault(),
                                this.showDeclineContent(),
                                Shopify.designMode && sessionStorage.setItem(this.id, "second-view");
                        }),
                    this.returnButton &&
                        this.returnButton.addEventListener("click", (e) => {
                            e.preventDefault(), this.hideDeclineContent();
                            e = sessionStorage.getItem(this.id);
                            Shopify.designMode && e && sessionStorage.removeItem(this.id);
                        }),
                    this.exitButton &&
                        this.exitButton.addEventListener("click", (e) => {
                            e.preventDefault(),
                                "false" === this.dataset.testMode &&
                                    Cookies.set(this.cookieName, "entered", {
                                        expires: 30,
                                        sameSite: "none",
                                        secure: !0,
                                    }),
                                this.backgroundImage && (this.backgroundImage.style.display = "none"),
                                theme.config.bpSmall &&
                                    this.mobileBackgroundImage &&
                                    (this.mobileBackgroundImage.style.display = "none"),
                                this.modal.close(),
                                theme.a11y.unlockMobileScrolling("#" + this.id, document.querySelector("#MainContent"));
                        });
            }
            showDeclineContent() {
                this.declineContent.classList.remove(this.classes.inactiveDeclineContent),
                    this.declineContent.classList.add(this.classes.activeDeclineContent),
                    this.content.classList.add(this.classes.inactiveContent),
                    this.content.classList.remove(this.classes.activeContent);
            }
            hideDeclineContent() {
                this.declineContent.classList.add(this.classes.inactiveDeclineContent),
                    this.declineContent.classList.remove(this.classes.activeDeclineContent),
                    this.content.classList.remove(this.classes.inactiveContent),
                    this.content.classList.add(this.classes.activeContent);
            }
        }
        function Qt(e) {
            (this.container = e),
                (this.sectionId = this.container.getAttribute("data-section-id")),
                (this.namespace = ".map-" + this.sectionId),
                (this.map = e.querySelector(xe)),
                (this.key = this.map.dataset.apiKey),
                (L = {
                    addressNoResults: theme.strings.addressNoResults,
                    addressQueryLimit: theme.strings.addressQueryLimit,
                    addressError: theme.strings.addressError,
                    authError: theme.strings.authError,
                }),
                this.key &&
                    theme.initWhenVisible({
                        element: this.container,
                        callback: this.prepMapApi.bind(this),
                        threshold: 20,
                    });
        }
        function Wt(e) {
            this.container = e;
            var t = this.container.getAttribute("data-section-id");
            (this.cookieName = "newsletter-" + t),
                (this.cookie = Cookies.get(this.cookieName)),
                e &&
                    "/challenge" !== window.location.pathname &&
                    "/password" !== window.location.pathname &&
                    ((this.data = {
                        secondsBeforeShow: e.dataset.delaySeconds,
                        daysBeforeReappear: e.dataset.delayDays,
                        hasReminder: e.dataset.hasReminder,
                        testMode: e.dataset.testMode,
                    }),
                    (this.modal = new theme.Modals("NewsletterPopup-" + t, "newsletter-popup-modal")),
                    (t = e.querySelector(".popup-cta a")) &&
                        t.addEventListener(
                            "click",
                            function () {
                                this.closePopup(!0);
                            }.bind(this)
                        ),
                    (e.querySelector(".errors") || e.querySelector(".note--success")) && this.modal.open(),
                    e.querySelector(".note--success")
                        ? this.closePopup(!0)
                        : (document.addEventListener("modalClose." + e.id, this.closePopup.bind(this)),
                          this.cookie || this.initPopupDelay(),
                          document.addEventListener("reminder:openNewsletter", () => {
                              this.modal.open();
                          })));
        }
        function $t() {
            this.init();
        }
        function Xt(e, t) {
            (this.container = e),
                (this.sectionId = t),
                (this.namespace = ".photoswipe-" + this.sectionId),
                this.gallery,
                this.images,
                this.items,
                (this.inSlideshow = !1),
                e && "false" !== e.dataset.zoom && this.init();
        }
        customElements.define("age-verification-popup", zt),
            (theme.Maps =
                ((Ce = 14),
                (w = null),
                (qe = []),
                (L = {}),
                (Ae = '[data-section-type="map"]'),
                (xe = "[data-map]"),
                (Te = ".map-section__overlay"),
                (window.gm_authFailure = function () {
                    Shopify.designMode &&
                        (document.querySelectorAll(Ae).forEach((e) => {
                            e.classList.add("map-section--load-error");
                        }),
                        document.querySelectorAll(xe).forEach((e) => {
                            e.parentNode.removeChild(e);
                        }),
                        window.mapError(theme.strings.authError));
                }),
                (window.mapError = function (e) {
                    var t = document.createElement("div");
                    t.classList.add("map-section__error", "errors", "text-center"),
                        (t.innerHTML = e),
                        document.querySelectorAll(Te).forEach((e) => {
                            e.parentNode.prepend(t);
                        }),
                        document.querySelectorAll(".map-section__link").forEach((e) => {
                            e.classList.add("hide");
                        });
                }),
                (Qt.prototype = Object.assign({}, Qt.prototype, {
                    prepMapApi: function () {
                        var e;
                        "loaded" === w
                            ? this.createMap()
                            : (qe.push(this),
                              "loading" !== w &&
                                  ((w = "loading"),
                                  (void 0 !== window.google && void 0 !== window.google.maps) ||
                                      (((e = document.createElement("script")).onload = function () {
                                          (w = "loaded"),
                                              qe.forEach((e) => {
                                                  e.createMap();
                                              });
                                      }),
                                      (e.src = "https://maps.googleapis.com/maps/api/js?key=" + this.key),
                                      document.head.appendChild(e))));
                    },
                    createMap: function () {
                        var s = this.map;
                        return ((e) => {
                            var t,
                                n = new google.maps.Geocoder();
                            if (e)
                                return (
                                    (t = e.dataset.addressSetting),
                                    new Promise((i, s) => {
                                        n.geocode({ address: t }, function (e, t) {
                                            t !== google.maps.GeocoderStatus.OK && s(t), i(e);
                                        });
                                    })
                                );
                        })(s)
                            .then(
                                function (e) {
                                    var e = {
                                            zoom: Ce,
                                            backgroundColor: "none",
                                            center: e[0].geometry.location,
                                            draggable: !1,
                                            clickableIcons: !1,
                                            scrollwheel: !1,
                                            disableDoubleClickZoom: !0,
                                            disableDefaultUI: !0,
                                        },
                                        t = (this.map = new google.maps.Map(s, e)),
                                        i = (this.center = t.getCenter());
                                    new google.maps.Marker({ map: t, position: t.getCenter() });
                                    google.maps.event.addDomListener(
                                        window,
                                        "resize",
                                        theme.utils.debounce(250, function () {
                                            google.maps.event.trigger(t, "resize"),
                                                t.setCenter(i),
                                                s.removeAttribute("style");
                                        })
                                    ),
                                        Shopify.designMode && window.AOS && AOS.refreshHard();
                                }.bind(this)
                            )
                            .catch(function (e) {
                                var t;
                                switch (e) {
                                    case "ZERO_RESULTS":
                                        t = L.addressNoResults;
                                        break;
                                    case "OVER_QUERY_LIMIT":
                                        t = L.addressQueryLimit;
                                        break;
                                    case "REQUEST_DENIED":
                                        t = L.authError;
                                        break;
                                    default:
                                        t = L.addressError;
                                }
                                Shopify.designMode && window.mapError(t);
                            });
                    },
                    onUnload: function () {
                        0 !== this.map.length &&
                            google &&
                            google.maps &&
                            google.maps.event &&
                            google.maps.event.clearListeners(this.map, "resize");
                    },
                })),
                Qt)),
            (theme.NewsletterPopup =
                ((Wt.prototype = Object.assign({}, Wt.prototype, {
                    initPopupDelay: function () {
                        "true" !== this.data.testMode &&
                            setTimeout(
                                function () {
                                    var e;
                                    "true" === sessionStorage.getItem("newsletterAppeared")
                                        ? ((e = new CustomEvent("newsletter:openReminder", { bubbles: !0 })),
                                          this.container.dispatchEvent(e))
                                        : (this.modal.open(), sessionStorage.setItem("newsletterAppeared", !0));
                                }.bind(this),
                                1e3 * this.data.secondsBeforeShow
                            );
                    },
                    closePopup: function (e) {
                        var t, i;
                        "true" === this.data.testMode
                            ? Cookies.remove(this.cookieName, { path: "/" })
                            : ((e = e ? 200 : this.data.daysBeforeReappear),
                              (t = "true" === this.data.hasReminder),
                              (i = "true" === sessionStorage.getItem("reminderAppeared")),
                              ((t && i) || !t) && Cookies.set(this.cookieName, "opened", { path: "/", expires: e }));
                    },
                    onLoad: function () {
                        this.modal.open();
                    },
                    onSelect: function () {
                        this.modal.open();
                    },
                    onDeselect: function () {
                        this.modal.close();
                    },
                    onBlockSelect: function () {
                        this.modal.close();
                    },
                    onBlockDeselect: function () {
                        this.modal.open();
                    },
                    onUnload: function () {
                        this.modal.close();
                    },
                })),
                Wt)),
            (theme.PasswordHeader =
                (($t.prototype = Object.assign({}, $t.prototype, {
                    init: function () {
                        var e;
                        document.querySelector("#LoginModal") &&
                            ((e = new theme.Modals("LoginModal", "login-modal", {
                                focusIdOnOpen: "password",
                                solid: !0,
                            })),
                            document.querySelectorAll(".errors").length) &&
                            e.open();
                    },
                })),
                $t)),
            (theme.Photoswipe =
                ((Oe = ".js-photoswipe__zoom"),
                (Pe = ".photoswipe__image"),
                (Me = ".flickity-viewport "),
                (Ve = ".is-selected"),
                (Xt.prototype = Object.assign({}, Xt.prototype, {
                    init: function () {
                        this.container.querySelectorAll(Oe).forEach((e) => {
                            e.on("click" + this.namespace, this.triggerClick.bind(this));
                        });
                    },
                    triggerClick: function (e) {
                        this.container.dataset && "true" === this.container.dataset.hasSlideshow
                            ? (this.inSlideshow = !0)
                            : (this.inSlideshow = !1),
                            (this.items = this.getImageData());
                        (e = this.inSlideshow ? this.container.querySelector(Ve) : e.currentTarget),
                            (e = this.inSlideshow ? this.getChildIndex(e) : e.dataset.index);
                        this.initGallery(this.items, e);
                    },
                    getChildIndex: function (e) {
                        for (var t = 0; null != (e = e.previousSibling); ) t++;
                        return t + 1;
                    },
                    getImageData: function () {
                        this.images = this.inSlideshow
                            ? this.container.querySelectorAll(Me + Pe)
                            : this.container.querySelectorAll(Pe);
                        var t = [];
                        return (
                            this.images.forEach((e) => {
                                e = {
                                    msrc: e.currentSrc || e.src,
                                    src: e.getAttribute("data-photoswipe-src"),
                                    w: e.getAttribute("data-photoswipe-width"),
                                    h: e.getAttribute("data-photoswipe-height"),
                                    el: e,
                                    initialZoomLevel: 0.5,
                                };
                                t.push(e);
                            }),
                            t
                        );
                    },
                    initGallery: function (i, e) {
                        var t = document.querySelectorAll(".pswp")[0];
                        (this.gallery = new PhotoSwipe(t, PhotoSwipeUI_Default, i, {
                            allowPanToNext: !1,
                            captionEl: !1,
                            closeOnScroll: !1,
                            counterEl: !1,
                            history: !1,
                            index: e - 1,
                            pinchToClose: !1,
                            preloaderEl: !1,
                            scaleMode: "zoom",
                            shareEl: !1,
                            tapToToggleControls: !1,
                            getThumbBoundsFn: function (e) {
                                var t = window.pageYOffset || document.documentElement.scrollTop,
                                    e = i[e].el.getBoundingClientRect();
                                return { x: e.left, y: e.top + t, w: e.width };
                            },
                        })),
                            this.gallery.listen("afterChange", this.afterChange.bind(this)),
                            this.gallery.init(),
                            this.preventiOS15Scrolling();
                    },
                    afterChange: function () {
                        var e = this.gallery.getCurrentIndex();
                        this.container.dispatchEvent(
                            new CustomEvent("photoswipe:afterChange", { detail: { index: e } })
                        );
                    },
                    syncHeight: function () {
                        document.documentElement.style.setProperty("--window-inner-height", window.innerHeight + "px");
                    },
                    preventiOS15Scrolling: function () {
                        let e;
                        /iPhone|iPad|iPod/i.test(window.navigator.userAgent) &&
                            (this.syncHeight(),
                            (e = window.scrollY),
                            document.documentElement.classList.add("pswp-open-in-ios"),
                            window.addEventListener("resize", this.syncHeight),
                            this.gallery.listen("destroy", () => {
                                document.documentElement.classList.remove("pswp-open-in-ios"), window.scrollTo(0, e);
                            }));
                    },
                })),
                Xt));
        class Gt extends HTMLElement {
            constructor() {
                super(),
                    ((this.el = this).url = this.dataset.url),
                    (this.intent = this.dataset.intent),
                    (this.placeholder = this.querySelector(".product-recommendations-placeholder")),
                    (this.productResults = this.querySelector(".grid-product")),
                    (this.sectionId = this.dataset.sectionId),
                    (this.blockId = this.dataset.blockId),
                    document.addEventListener("recommendations:loaded", (e) => {
                        (this.colorImages = this.el.querySelectorAll(".grid-product__color-image")),
                            this.colorImages.length &&
                                ((this.swatches = this.el.querySelectorAll(".color-swatch--with-image")),
                                this.colorSwatchHovering());
                    });
            }
            connectedCallback() {
                fetch(this.url)
                    .then((e) => e.text())
                    .then((e) => {
                        var t = document.createElement("div"),
                            e = ((t.innerHTML = e), t.querySelector(".product-recommendations"));
                        e
                            ? ((this.placeholder.innerHTML = ""),
                              (this.placeholder.innerHTML = e.innerHTML),
                              theme.reinitProductGridItem(this.el),
                              (this.slideshow = this.querySelector("[data-slideshow]")),
                              this.slideshow && this.setupSlider(),
                              document.dispatchEvent(
                                  new CustomEvent("recommendations:loaded", {
                                      detail: { section: this.el, intent: this.intent },
                                  })
                              ))
                            : (this.el.classList.add("hide"), AOS && AOS.refreshHard());
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            }
            setupSlider() {
                var e = this.slideshow.dataset.controls,
                    t = parseFloat(this.slideshow.dataset.perSlide),
                    i = parseFloat(this.slideshow.dataset.count);
                let s = !1,
                    n = !0;
                "arrows" === e && ((n = !1), (s = !0)),
                    t < i &&
                        (this.flickity = new theme.Slideshow(this.slideshow, {
                            prevNextButtons: s,
                            pageDots: n,
                            adaptiveHeight: !0,
                            wrapAround: !1,
                        }));
            }
            colorSwatchHovering() {
                this.swatches.forEach((t) => {
                    t.addEventListener(
                        "mouseenter",
                        function () {
                            this.setActiveColorImage(t);
                        }.bind(this)
                    ),
                        t.addEventListener(
                            "touchstart",
                            function (e) {
                                e.preventDefault(), this.setActiveColorImage(t);
                            }.bind(this),
                            { passive: !0 }
                        ),
                        t.addEventListener(
                            "mouseleave",
                            function () {
                                this.removeActiveColorImage(t);
                            }.bind(this)
                        );
                });
            }
            setActiveColorImage(e) {
                var t = e.dataset.variantId,
                    i = e.dataset.variantImage,
                    t =
                        (this.colorImages.forEach((e) => {
                            e.classList.remove("is-active");
                        }),
                        this.swatches.forEach((e) => {
                            e.classList.remove("is-active");
                        }),
                        this.el.querySelector(".grid-product__color-image--" + t)),
                    i =
                        ((t.style.backgroundImage = "url(" + i + ")"),
                        t.classList.add("is-active"),
                        e.classList.add("is-active"),
                        e.dataset.url);
                e.closest(".grid-item__link").setAttribute("href", i);
            }
            removeActiveColorImage(e) {
                e = e.dataset.variantId;
                this.el.querySelector(".grid-product__color-image--" + e).classList.remove("is-active");
            }
        }
        function Yt(e) {
            var t = (this.container = e).getAttribute("data-section-id");
            (this.slideshow = e.querySelector("#Slideshow-" + t)),
                (this.namespace = "." + t),
                (this.initialIndex = 0),
                this.slideshow &&
                    ((t = e.parentElement),
                    0 === [].indexOf.call(t.parentElement.children, t)
                        ? this.init()
                        : theme.initWhenVisible({ element: this.container, callback: this.init.bind(this) }));
        }
        function Jt(e) {
            (this.container = e), (this.baseUrl = e.dataset.baseUrl), (this.productTitle = e.dataset.productName);
        }
        function Kt(e) {
            (this.container = e),
                (this.sectionId = e.getAttribute("data-section-id")),
                (this.namespace = ".video-" + this.sectionId),
                this.videoObject,
                theme.initWhenVisible({ element: this.container, callback: this.init.bind(this), threshold: 500 });
        }
        customElements.define("product-recommendations", Gt),
            (theme.SlideshowSection =
                ((Yt.prototype = Object.assign({}, Yt.prototype, {
                    init: function () {
                        var e,
                            t = this.slideshow.querySelectorAll(".slideshow__slide");
                        this.slideshow.classList.remove("loading", "loading--delayed"),
                            this.slideshow.classList.add("loaded"),
                            1 < t.length
                                ? ((e = {
                                      prevNextButtons: this.slideshow.hasAttribute("data-arrows"),
                                      pageDots: this.slideshow.hasAttribute("data-dots"),
                                      fade: !0,
                                      setGallerySize: !1,
                                      initialIndex: this.initialIndex,
                                      autoPlay:
                                          "true" === this.slideshow.dataset.autoplay &&
                                          parseInt(this.slideshow.dataset.speed),
                                  }),
                                  (this.flickity = new theme.Slideshow(this.slideshow, e)))
                                : t[0].classList.add("is-selected");
                    },
                    forceReload: function () {
                        this.onUnload(), this.init();
                    },
                    onUnload: function () {
                        this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy();
                    },
                    onDeselect: function () {
                        this.flickity && "function" == typeof this.flickity.play && this.flickity.play();
                    },
                    onBlockSelect: function (e) {
                        (e = this.slideshow.querySelector(".slideshow__slide--" + e.detail.blockId)),
                            (e = parseInt(e.dataset.index));
                        this.flickity && "function" == typeof this.flickity.pause
                            ? (this.flickity.goToSlide(e), this.flickity.pause())
                            : ((this.initialIndex = e),
                              setTimeout(
                                  function () {
                                      this.flickity &&
                                          "function" == typeof this.flickity.pause &&
                                          this.flickity.pause();
                                  }.bind(this),
                                  1e3
                              ));
                    },
                    onBlockDeselect: function () {
                        this.flickity &&
                            "function" == typeof this.flickity.play &&
                            this.flickity.args.autoPlay &&
                            this.flickity.play();
                    },
                })),
                Yt)),
            (theme.StoreAvailability =
                ((He = ".js-drawer-open-availability"),
                (De = ".js-modal-open-availability"),
                (Fe = "[data-availability-product-title]"),
                (Jt.prototype = Object.assign({}, Jt.prototype, {
                    updateContent: function (e) {
                        var e = this.baseUrl + "/variants/" + e + "/?section_id=store-availability",
                            t = this;
                        fetch(e)
                            .then(function (e) {
                                return e.text();
                            })
                            .then(function (e) {
                                "" === e.trim()
                                    ? (this.container.innerHTML = "")
                                    : ((t.container.innerHTML = e),
                                      (t.container.innerHTML = t.container.firstElementChild.innerHTML),
                                      t.container.querySelector(He) &&
                                          (t.drawer = new theme.Drawers("StoreAvailabilityDrawer", "availability")),
                                      t.container.querySelector(De) &&
                                          (t.modal = new theme.Modals("StoreAvailabilityModal", "availability")),
                                      (e = t.container.querySelector(Fe)) && (e.textContent = t.productTitle));
                            });
                    },
                })),
                Jt)),
            (theme.VideoSection =
                ((E = ".video-parent-section"),
                (Kt.prototype = Object.assign({}, Kt.prototype, {
                    init: function () {
                        var e = this.container.querySelector(".video-div");
                        if (e)
                            switch (e.dataset.type) {
                                case "youtube":
                                    var t = e.dataset.videoId;
                                    this.initYoutubeVideo(t);
                                    break;
                                case "vimeo":
                                    t = e.dataset.videoId;
                                    this.initVimeoVideo(t);
                                    break;
                                case "mp4":
                                    this.initMp4Video();
                            }
                    },
                    initYoutubeVideo: function (e) {
                        this.videoObject = new theme.YouTube("YouTubeVideo-" + this.sectionId, {
                            videoId: e,
                            videoParent: E,
                        });
                    },
                    initVimeoVideo: function (e) {
                        this.videoObject = new theme.VimeoPlayer("Vimeo-" + this.sectionId, e, { videoParent: E });
                    },
                    initMp4Video: function () {
                        var e = "Mp4Video-" + this.sectionId,
                            t = document.getElementById(e),
                            i = t.closest(E);
                        t &&
                            (i.classList.add("loaded"), void 0 !== (e = document.querySelector("#" + e).play())) &&
                            e
                                .then(function () {})
                                .catch(function () {
                                    t.setAttribute("controls", ""), i.classList.add("video-interactable");
                                });
                    },
                    onUnload: function (e) {
                        e.target.id.replace("shopify-section-", "");
                        this.videoObject && "function" == typeof this.videoObject.destroy && this.videoObject.destroy();
                    },
                })),
                Kt));
        class Zt extends HTMLElement {
            constructor() {
                super(),
                    ((this.el = this).display = this.querySelector("[data-time-display]")),
                    (this.block = this.closest(".countdown__block--timer")),
                    (this.year = this.el.dataset.year),
                    (this.month = this.el.dataset.month),
                    (this.day = this.el.dataset.day),
                    (this.hour = this.el.dataset.hour),
                    (this.minute = this.el.dataset.minute),
                    (this.daysPlaceholder = this.querySelector("[date-days-placeholder]")),
                    (this.hoursPlaceholder = this.querySelector("[date-hours-placeholder]")),
                    (this.minutesPlaceholder = this.querySelector("[date-minutes-placeholder]")),
                    (this.secondsPlaceholder = this.querySelector("[date-seconds-placeholder]")),
                    (this.messagePlaceholder = this.querySelector("[data-message-placeholder]")),
                    (this.hideTimerOnComplete = this.el.dataset.hideTimer),
                    (this.completeMessage = this.el.dataset.completeMessage),
                    (this.timerComplete = !1),
                    this.init();
            }
            init() {
                setInterval(() => {
                    this.timerComplete || this._calculate();
                }, 1e3);
            }
            _calculate() {
                var e =
                    +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() -
                    +new Date().getTime();
                0 < e
                    ? ((e = {
                          days: Math.floor(e / 864e5),
                          hours: Math.floor((e / 36e5) % 24),
                          minutes: Math.floor((e / 1e3 / 60) % 60),
                          seconds: Math.floor((e / 1e3) % 60),
                      }),
                      (this.daysPlaceholder.innerHTML = e.days),
                      (this.hoursPlaceholder.innerHTML = e.hours),
                      (this.minutesPlaceholder.innerHTML = e.minutes),
                      (this.secondsPlaceholder.innerHTML = e.seconds),
                      setTimeout(() => {
                          this.display.classList.add("countdown__display--loaded");
                      }, 1))
                    : (this.completeMessage &&
                          this.messagePlaceholder &&
                          this.messagePlaceholder.classList.add("countdown__timer-message--visible"),
                      "true" === this.hideTimerOnComplete &&
                          (this.display.classList.remove("countdown__display--visible"),
                          this.display.classList.add("countdown__display--hidden")),
                      this.completeMessage ||
                          "true" !== this.hideTimerOnComplete ||
                          this.block.classList.add("countdown__block--hidden"),
                      (this.timerComplete = !0));
            }
        }
        customElements.define("countdown-timer", Zt);
        class ei extends HTMLElement {
            constructor() {
                super(),
                    ((this.el = this).buttons = this.querySelectorAll("[data-button]")),
                    (this.hotspotBlocks = this.querySelectorAll("[data-hotspot-block]")),
                    (this.blockContainer = this.querySelector("[data-block-container]")),
                    (this.colorImages = this.querySelectorAll(".grid-product__color-image")),
                    (this.colorSwatches = this.querySelectorAll(".color-swatch--with-image")),
                    this._bindEvents(),
                    this._setupQuickShop(),
                    this.colorImages.length && this._colorSwatchHovering();
            }
            _colorSwatchHovering() {
                this.colorSwatches.forEach((t) => {
                    t.addEventListener(
                        "mouseenter",
                        function () {
                            this._setActiveColorImage(t);
                        }.bind(this)
                    ),
                        t.addEventListener(
                            "touchstart",
                            function (e) {
                                e.preventDefault(), this._setActiveColorImage(t);
                            }.bind(this),
                            { passive: !0 }
                        ),
                        t.addEventListener(
                            "mouseleave",
                            function () {
                                this._removeActiveColorImage(t);
                            }.bind(this)
                        );
                });
            }
            _setActiveColorImage(e) {
                var t = e.dataset.variantId,
                    i = e.dataset.variantImage,
                    t =
                        (this.colorImages.forEach((e) => {
                            e.classList.remove("is-active");
                        }),
                        this.colorSwatches.forEach((e) => {
                            e.classList.remove("is-active");
                        }),
                        this.el.querySelector(".grid-product__color-image--" + t)),
                    i =
                        ((t.style.backgroundImage = "url(" + i + ")"),
                        t.classList.add("is-active"),
                        e.classList.add("is-active"),
                        e.dataset.url),
                    t = e.closest(".grid-item__link");
                t && t.setAttribute("href", i);
            }
            _removeActiveColorImage(e) {
                e = e.dataset.variantId;
                this.querySelector(".grid-product__color-image--" + e).classList.remove("is-active");
            }
            _bindEvents() {
                this.buttons.forEach((e) => {
                    let t = e.dataset.button;
                    e.on("click", (e) => {
                        e.preventDefault(), e.stopPropagation(), this._showContent(t);
                    });
                }),
                    document.addEventListener("shopify:block:select", (e) => {
                        e = e.detail.blockId;
                        this._showContent("" + e);
                    });
            }
            _showContent(t) {
                this.hotspotBlocks.forEach((e) => {
                    e.dataset.hotspotBlock === t ? e.classList.add("is-active") : e.classList.remove("is-active");
                });
            }
            _setupQuickShop() {
                0 < this.querySelectorAll('[data-block-type="product"]').length &&
                    ("function" == typeof theme.QuickShop
                        ? new theme.QuickShop(this.blockContainer)
                        : "function" == typeof theme.initQuickShop && theme.initQuickShop(),
                    "function" == typeof theme.QuickAdd) &&
                    new theme.QuickAdd(this.blockContainer);
            }
        }
        customElements.define("hot-spots", ei);
        class ti extends HTMLElement {
            constructor() {
                super(),
                    ((this.el = this).sectionId = this.dataset.sectionId),
                    (this.button = this.querySelector("[data-button]")),
                    (this.draggableContainer = this.querySelector("[data-draggable]")),
                    (this.primaryImage = this.querySelector("[data-primary-image]")),
                    (this.secondaryImage = this.querySelector("[data-secondary-image]")),
                    this.calculateSizes(),
                    (this.active = !1),
                    (this.currentX = 0),
                    (this.initialX = 0),
                    (this.xOffset = 0),
                    (this.buttonOffset = this.button.offsetWidth / 2),
                    this.el.addEventListener("touchstart", this.dragStart, !1),
                    this.el.addEventListener("touchend", this.dragEnd, !1),
                    this.el.addEventListener("touchmove", this.drag, !1),
                    this.el.addEventListener("mousedown", this.dragStart, !1),
                    this.el.addEventListener("mouseup", this.dragEnd, !1),
                    this.el.addEventListener("mousemove", this.drag, !1),
                    window.on(
                        "resize",
                        theme.utils.debounce(250, () => {
                            this.calculateSizes(!0);
                        })
                    ),
                    document.addEventListener("shopify:section:load", (e) => {
                        e.detail.sectionId === this.sectionId && null !== this.primaryImage && this.calculateSizes();
                    });
            }
            calculateSizes(e = !1) {
                (this.active = !1),
                    (this.currentX = 0),
                    (this.initialX = 0),
                    (this.xOffset = 0),
                    (this.buttonOffset = this.button.offsetWidth / 2),
                    (this.elWidth = this.el.offsetWidth),
                    (this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`),
                    this.primaryImage && (this.primaryImage.style.width = this.elWidth + "px"),
                    e && (this.draggableContainer.style.width = this.elWidth / 2 + "px");
            }
            dragStart(e) {
                "touchstart" === e.type
                    ? (this.initialX = e.touches[0].clientX - this.xOffset)
                    : (this.initialX = e.clientX - this.xOffset),
                    e.target === this.button && (this.active = !0);
            }
            dragEnd(e) {
                (this.initialX = this.currentX), (this.active = !1);
            }
            drag(e) {
                this.active &&
                    (e.preventDefault(),
                    "touchmove" === e.type
                        ? (this.currentX = e.touches[0].clientX - this.initialX)
                        : (this.currentX = e.clientX - this.initialX),
                    (this.xOffset = this.currentX),
                    this.setTranslate(this.currentX, this.button));
            }
            setTranslate(e, t) {
                let i = e - this.buttonOffset,
                    s = this.elWidth / 2 + e;
                var e = -1 * (this.elWidth / 2 + this.buttonOffset),
                    n = this.elWidth / 2 - this.buttonOffset;
                i < 50 + e ? ((i = 50 + e), (s = 50)) : i > n - 50 && ((i = n - 50), (s = this.elWidth - 50)),
                    (t.style.transform = `translate(${i}px, -50%)`),
                    (this.draggableContainer.style.width = s + "px");
            }
        }
        function ii(e) {
            this.tagFilters();
        }
        function si(e) {
            this.namespace = ".collection-header";
            e = e.querySelector(".collection-hero");
            e
                ? (je && this.checkIfNeedReload(),
                  e.classList.remove("loading", "loading--delayed"),
                  e.classList.add("loaded"))
                : theme.settings.overlayHeader && theme.headerNav.disableOverlayHeader(),
                (je = !0);
        }
        function ni(e) {
            this.container = e.querySelector(Be);
        }
        function oi(e) {
            (this.container = e),
                (this.sectionId = e.getAttribute("data-section-id")),
                (this.namespace = ".collection-" + this.sectionId),
                (this.sidebar = new theme.CollectionSidebar(e)),
                (this.context = e.getAttribute("data-context")),
                (this.ajaxRenderer = new theme.AjaxRenderer({
                    sections: [{ sectionId: this.sectionId, nodeId: "CollectionAjaxContent" }],
                    onReplace: this.onReplaceAjaxContent.bind(this),
                })),
                this.init();
        }
        function ai(e) {
            (this.container = e), (this.localeDisclosure = null), (this.currencyDisclosure = null), this.init();
        }
        function ri(e) {
            (this.container = e), (this.sectionId = this.container.getAttribute("data-section-id")), this.init();
        }
        function ci(e) {
            this.container = e;
            var t = (this.sectionId = e.getAttribute("data-section-id")),
                i = (this.productId = e.getAttribute("data-product-id")),
                e =
                    ((this.inModal = "true" === e.dataset.modal),
                    this.modal,
                    (this.settings = {
                        enableHistoryState: e.dataset.history || !1,
                        namespace: ".product-" + t,
                        inventory: !1,
                        inventoryThreshold: 10,
                        modalInit: !1,
                        hasImages: !0,
                        imageSetName: null,
                        imageSetIndex: null,
                        currentImageSet: null,
                        imageSize: "620x",
                        currentSlideIndex: 0,
                        videoLooping: e.dataset.videoLooping,
                    }),
                    this.inModal &&
                        ((this.settings.enableHistoryState = !1),
                        (this.settings.namespace = ".product-" + t + "-modal"),
                        (this.modal = document.getElementById("QuickShopModal-" + i))),
                    (this.selectors = {
                        variantsJson: "[data-variant-json]",
                        currentVariantJson: "[data-current-variant-json]",
                        form: ".product-single__form",
                        media: "[data-product-media-type-model]",
                        closeMedia: ".product-single__close-media",
                        photoThumbs: "[data-product-thumb]",
                        thumbSlider: "[data-product-thumbs]",
                        thumbScroller: ".product__thumbs--scroller",
                        mainSlider: "[data-product-photos]",
                        imageContainer: "[data-product-images]",
                        productImageMain: "[data-product-image-main]",
                        priceWrapper: "[data-product-price-wrap]",
                        price: "[data-product-price]",
                        comparePrice: "[data-compare-price]",
                        savePrice: "[data-save-price]",
                        priceA11y: "[data-a11y-price]",
                        comparePriceA11y: "[data-compare-price-a11y]",
                        unitWrapper: "[data-unit-price-wrapper]",
                        unitPrice: "[data-unit-price]",
                        unitPriceBaseUnit: "[data-unit-base]",
                        sku: "[data-sku]",
                        inventory: "[data-product-inventory]",
                        incomingInventory: "[data-incoming-inventory]",
                        colorLabel: "[data-variant-color-label]",
                        addToCart: "[data-add-to-cart]",
                        addToCartText: "[data-add-to-cart-text]",
                        originalSelectorId: "[data-product-select]",
                        singleOptionSelector: "[data-variant-input]",
                        variantColorSwatch: ".variant__input--color-swatch",
                        dynamicVariantsEnabled: "[data-dynamic-variants-enabled]",
                        availabilityContainer: "[data-store-availability-holder]",
                    }),
                    this.cacheElements(),
                    (this.firstProductImage = this.cache.mainSlider.querySelector("img")),
                    this.firstProductImage || (this.settings.hasImages = !1),
                    this.cache.mainSlider.querySelector("[data-set-name]"));
            e && (this.settings.imageSetName = e.dataset.setName), this.init();
        }
        function di(e) {
            e &&
                ((this.container = e),
                (this.sectionId = this.container.getAttribute("data-section-id")),
                (this.namespace = ".recently-viewed" + this.sectionId),
                (this.gridItemWidth = this.container.getAttribute("data-grid-item-class")),
                (this.rowOf = this.container.getAttribute("data-row-of")),
                (this.imageSizes = this.container.getAttribute("data-image-sizes")),
                theme.initWhenVisible({ element: this.container, callback: this.init.bind(this), threshold: 600 }));
        }
        function li(e) {
            (this.container = e), this.timeout;
            var t = e.getAttribute("data-section-id");
            (this.slideshow = e.querySelector("#Testimonials-" + t)),
                (this.namespace = ".testimonial-" + t),
                this.slideshow &&
                    theme.initWhenVisible({ element: this.container, callback: this.init.bind(this), threshold: 600 });
        }
        customElements.define("image-compare", ti),
            (theme.Blog =
                ((ii.prototype = Object.assign({}, ii.prototype, {
                    tagFilters: function () {
                        var e = document.getElementById("BlogTagFilter");
                        e &&
                            e.addEventListener("change", function () {
                                location.href = e.value;
                            });
                    },
                })),
                ii)),
            (theme.CollectionHeader =
                ((je = !1),
                (si.prototype = Object.assign({}, si.prototype, {
                    checkIfNeedReload: function () {
                        Shopify.designMode &&
                            theme.settings.overlayHeader &&
                            !document.querySelector(".header-wrapper").classList.contains("header-wrapper--overlay") &&
                            location.reload();
                    },
                })),
                si)),
            (theme.CollectionSidebar =
                ((_ = !1),
                (Be = "#CollectionSidebar"),
                (ni.prototype = Object.assign({}, ni.prototype, {
                    init: function () {
                        this.container &&
                            (this.onUnload(),
                            (_ = "drawer" === this.container.dataset.style),
                            (theme.FilterDrawer = new theme.Drawers("FilterDrawer", "collection-filters", !0)));
                    },
                    forceReload: function () {
                        this.init();
                    },
                    onSelect: function () {
                        theme.FilterDrawer &&
                            (_ ? (_ || theme.config.bpSmall) && theme.FilterDrawer.open() : theme.FilterDrawer.close());
                    },
                    onDeselect: function () {
                        theme.FilterDrawer && theme.FilterDrawer.close();
                    },
                    onUnload: function () {
                        theme.FilterDrawer && theme.FilterDrawer.close();
                    },
                })),
                ni)),
            (theme.Collection =
                ((I = !1),
                (Re = "#SortBy"),
                (Ne = ".grid-product__color-image"),
                (Ue = ".color-swatch--with-image"),
                (ze = ".collection-grid__wrapper"),
                (Qe = ".collapsible-trigger"),
                (We = "#CollectionSidebar"),
                ($e = ".tag-list--active-tags"),
                (Xe = ".tag-list input"),
                (Ge = ".tag-list a"),
                (Ye = ".filter-form"),
                (Je = ".collection-filter"),
                (Ke = ".price-range"),
                (k = "tag--active"),
                (Ze = "tag--remove"),
                (et = "collapsible-content--sidebar"),
                (tt = "is-open"),
                (oi.prototype = Object.assign({}, oi.prototype, {
                    init: function () {
                        this.context && "featured-collection" === this.context
                            ? this.colorSwatchHovering()
                            : (this.initSort(),
                              this.colorSwatchHovering(),
                              this.initFilters(),
                              this.initPriceRange(),
                              this.sidebar.init());
                    },
                    initSort: function () {
                        (this.sortSelect = document.querySelector(Re)),
                            this.sortSelect &&
                                ((this.defaultSort = this.getDefaultSortValue()),
                                this.sortSelect.on("change" + this.namespace, this.onSortChange.bind(this)));
                    },
                    getSortValue: function () {
                        return this.sortSelect.value || this.defaultSort;
                    },
                    getDefaultSortValue: function () {
                        return this.sortSelect.getAttribute("data-default-sortby");
                    },
                    onSortChange: function () {
                        (this.queryParams = new URLSearchParams(window.location.search)),
                            this.queryParams.set("sort_by", this.getSortValue()),
                            this.queryParams.delete("page"),
                            (window.location.search = this.queryParams.toString());
                    },
                    colorSwatchHovering: function () {
                        this.container.querySelectorAll(Ne).length &&
                            this.container.querySelectorAll(Ue).forEach((i) => {
                                i.addEventListener("mouseenter", () => {
                                    var e = i.dataset.variantId,
                                        t = i.dataset.variantImage,
                                        e = this.container.querySelector(".grid-product__color-image--" + e);
                                    (e.style.backgroundImage = "url(" + t + ")"), e.classList.add("is-active");
                                }),
                                    i.addEventListener("mouseleave", () => {
                                        var e = i.dataset.variantId;
                                        this.container
                                            .querySelector(".grid-product__color-image--" + e)
                                            .classList.remove("is-active");
                                    });
                            });
                    },
                    initFilters: function () {
                        document.querySelectorAll(Xe).length &&
                            (this.bindBackButton(),
                            theme.config.stickyHeader &&
                                (this.setFilterStickyPosition(),
                                window.on("resize", theme.utils.debounce(500, this.setFilterStickyPosition))),
                            document.querySelectorAll(Ge).forEach((e) => {
                                e.addEventListener("click", this.tagClick.bind(this));
                            }),
                            document.querySelectorAll(Ye).forEach((e) => {
                                e.addEventListener("input", this.onFormSubmit.bind(this));
                            }));
                    },
                    initPriceRange: function () {
                        document
                            .querySelectorAll(Ke)
                            .forEach((e) => new theme.PriceRange(e, { onChange: this.renderFromFormData.bind(this) }));
                    },
                    tagClick: function (e) {
                        var t,
                            i = e.currentTarget;
                        theme.FilterDrawer && theme.FilterDrawer.close(),
                            i.classList.contains("no-ajax") ||
                                (e.preventDefault(), I) ||
                                ((I = !0),
                                (e = i.parentNode),
                                (t = new URL(i.href)),
                                this.renderActiveTag(e, i),
                                this.updateScroll(!0),
                                this.startLoading(),
                                this.renderCollectionPage(t.searchParams));
                    },
                    onFormSubmit: function (e) {
                        var t,
                            i = e.target;
                        theme.FilterDrawer && theme.FilterDrawer.close(),
                            i.classList.contains("no-ajax") ||
                                (e.preventDefault(), I) ||
                                ((I = !0),
                                (e = i.closest("li")),
                                (t = i.closest("form")),
                                (t = new FormData(t)),
                                this.renderActiveTag(e, i),
                                this.updateScroll(!0),
                                this.startLoading(),
                                this.renderFromFormData(t));
                    },
                    fetchOpenCollasibleFilters: function () {
                        return Array.from(document.querySelectorAll(We + ` ${Qe}.` + tt)).map(
                            (e) => e.dataset.collapsibleId
                        );
                    },
                    renderActiveTag: function (e, t) {
                        let s = e.querySelector(".tag__text");
                        e.classList.contains(k)
                            ? e.classList.remove(k)
                            : (e.classList.add(k),
                              t.closest("li").classList.contains(Ze)
                                  ? e.remove()
                                  : document.querySelectorAll($e).forEach((e) => {
                                        var t = document.createElement("li"),
                                            i = document.createElement("a");
                                        t.classList.add("tag", "tag--remove"),
                                            i.classList.add("btn", "btn--small"),
                                            (i.innerText = s.innerText),
                                            t.appendChild(i),
                                            e.appendChild(t);
                                    }));
                    },
                    renderFromFormData: function (e) {
                        e = new URLSearchParams(e);
                        this.renderCollectionPage(e);
                    },
                    onReplaceAjaxContent: function (t, e) {
                        this.fetchOpenCollasibleFilters().forEach((e) => {
                            t.querySelectorAll(`[data-collapsible-id=${e}]`).forEach(this.openCollapsible);
                        });
                        var i = t.getElementById(e.nodeId);
                        i && (document.getElementById(e.nodeId).innerHTML = i.innerHTML);
                    },
                    openCollapsible: function (e) {
                        e.classList.contains(et) && (e.style.height = "auto"), e.classList.add(tt);
                    },
                    renderCollectionPage: function (e, t = !0) {
                        this.ajaxRenderer.renderPage(window.location.pathname, e, t).then(() => {
                            theme.sections.reinit("collection-grid"),
                                this.updateScroll(!1),
                                this.initPriceRange(),
                                theme.reinitProductGridItem(),
                                document.dispatchEvent(new CustomEvent("collection:reloaded")),
                                (I = !1);
                        });
                    },
                    bindBackButton: function () {
                        window.off("popstate" + this.namespace),
                            window.on(
                                "popstate" + this.namespace,
                                function (e) {
                                    e &&
                                        ((e = new URL(window.location.href)),
                                        this.renderCollectionPage(e.searchParams, !1));
                                }.bind(this)
                            );
                    },
                    updateScroll: function (e) {
                        var t = document.querySelector("[data-scroll-to]"),
                            t = t && t.offsetTop;
                        theme.config.bpSmall || (t -= 15),
                            theme.config.stickyHeader && (t -= document.querySelector(".site-header").offsetHeight),
                            e ? window.scrollTo({ top: t, behavior: "smooth" }) : window.scrollTo({ top: t });
                    },
                    setFilterStickyPosition: function () {
                        var e = document.querySelector(".site-header").offsetHeight,
                            t =
                                ((document.querySelector(Je).style.top = e + 10 + "px"),
                                document.querySelector(".grid__item--sidebar"));
                        t && (t.style.top = e + 10 + "px");
                    },
                    forceReload: function () {
                        this.init();
                    },
                    startLoading: function () {
                        document.querySelector(ze).classList.add("unload");
                    },
                })),
                oi)),
            (theme.FooterSection =
                ((it = "[data-disclosure-locale]"),
                (st = "[data-disclosure-currency]"),
                (ai.prototype = Object.assign({}, ai.prototype, {
                    init: function () {
                        var e = this.container.querySelector(it),
                            t = this.container.querySelector(st),
                            i =
                                (e && (this.localeDisclosure = new theme.Disclosure(e)),
                                t && (this.currencyDisclosure = new theme.Disclosure(t)),
                                document.querySelector(".footer__newsletter-input"));
                        i &&
                            i.addEventListener("keyup", function () {
                                i.classList.add("footer__newsletter-input--active");
                            }),
                            theme.collapsibles.init(this.container);
                    },
                    onUnload: function () {
                        this.localeDisclosure && this.localeDisclosure.destroy(),
                            this.currencyDisclosure && this.currencyDisclosure.destroy();
                    },
                })),
                ai)),
            (theme.HeaderSection =
                ((nt = "[data-disclosure-locale]"),
                (ot = "[data-disclosure-currency]"),
                (ri.prototype = Object.assign({}, ri.prototype, {
                    init: function () {
                        Shopify &&
                            Shopify.designMode &&
                            (theme.sections.reinit("slideshow-section"),
                            setTimeout(function () {
                                window.dispatchEvent(new Event("resize"));
                            }, 500)),
                            this.initDrawers(),
                            this.initDisclosures(),
                            theme.headerNav.init(),
                            theme.announcementBar.init(),
                            this.hoverMenu();
                    },
                    hoverMenu: function () {
                        let s = document.querySelectorAll('[data-section-type="header"] details[data-hover="true"]');
                        s.forEach((e) => {
                            var t = e.querySelector("summary");
                            let i = t.dataset.link;
                            t.addEventListener("click", (e) => {
                                e.preventDefault(), (window.location.href = i);
                            }),
                                e.addEventListener("focusin", () => {
                                    e.hasAttribute("open") ||
                                        (s.forEach((e) => {
                                            e.removeAttribute("open"), e.setAttribute("aria-expanded", "false");
                                        }),
                                        e.setAttribute("open", ""),
                                        e.setAttribute("aria-expanded", "true"));
                                }),
                                e.addEventListener("focusout", () => {
                                    e.hasAttribute("open") &&
                                        !e.matches(":focus-within") &&
                                        (e.removeAttribute("open"), e.setAttribute("aria-expanded", "false"));
                                }),
                                e.addEventListener("mouseover", () => {
                                    e.hasAttribute("open") ||
                                        (e.setAttribute("open", ""), e.setAttribute("aria-expanded", "true"));
                                }),
                                e.addEventListener("mouseleave", () => {
                                    e.hasAttribute("open") &&
                                        (e.removeAttribute("open"), e.setAttribute("aria-expanded", "false"));
                                });
                        });
                    },
                    initDisclosures: function () {
                        var e = this.container.querySelector(nt),
                            t = this.container.querySelector(ot);
                        e && (this.localeDisclosure = new theme.Disclosure(e)),
                            t && (this.currencyDisclosure = new theme.Disclosure(t));
                    },
                    initDrawers: function () {
                        (theme.NavDrawer = new theme.Drawers("NavDrawer", "nav")),
                            "drawer" !== theme.settings.cartType ||
                                document.body.classList.contains("template-cart") ||
                                new theme.CartDrawer(),
                            theme.collapsibles.init(document.getElementById("NavDrawer"));
                    },
                    onUnload: function () {
                        theme.NavDrawer.close(),
                            theme.announcementBar.unload(),
                            this.localeDisclosure && this.localeDisclosure.destroy(),
                            this.currencyDisclosure && this.currencyDisclosure.destroy();
                    },
                })),
                ri)),
            (theme.Product =
                ((C = {}),
                (at = "on-sale"),
                (q = "disabled"),
                (rt = "is-modal"),
                (A = "hide"),
                (x = "inventory--low"),
                (T = ".product__video"),
                (O = ".product__video-wrapper"),
                (ct = ".product-main-slide"),
                (dt = ".is-selected"),
                (lt = ".secondary-slide"),
                (ht = ".variant-wrapper"),
                (ut = "[data-product-blocks]"),
                (mt = "[data-blocks-holder]"),
                (pt = "[data-dynamic-variants-enabled]"),
                (ci.prototype = Object.assign({}, ci.prototype, {
                    init: function () {
                        this.inModal &&
                            (this.container.classList.add(rt),
                            document.addEventListener(
                                "modalOpen.QuickShopModal-" + this.productId,
                                this.openModalProduct.bind(this)
                            ),
                            document.addEventListener(
                                "modalClose.QuickShopModal-" + this.productId,
                                this.closeModalProduct.bind(this)
                            )),
                            this.inModal ||
                                (this.formSetup(),
                                this.productSetup(),
                                this.videoSetup(),
                                this.initProductSlider(),
                                this.customMediaListners(),
                                this.addIdToRecentlyViewed());
                    },
                    cacheElements: function () {
                        this.cache = {
                            form: this.container.querySelector(this.selectors.form),
                            mainSlider: this.container.querySelector(this.selectors.mainSlider),
                            thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
                            thumbScroller: this.container.querySelector(this.selectors.thumbScroller),
                            productImageMain: this.container.querySelector(this.selectors.productImageMain),
                            priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
                            comparePriceA11y: this.container.querySelector(this.selectors.comparePriceA11y),
                            comparePrice: this.container.querySelector(this.selectors.comparePrice),
                            price: this.container.querySelector(this.selectors.price),
                            savePrice: this.container.querySelector(this.selectors.savePrice),
                            priceA11y: this.container.querySelector(this.selectors.priceA11y),
                        };
                    },
                    formSetup: function () {
                        this.initQtySelector(),
                            this.initAjaxProductForm(),
                            this.availabilitySetup(),
                            this.initVariants(),
                            this.settings.imageSetName && this.updateImageSet();
                    },
                    availabilitySetup: function () {
                        var e = this.container.querySelector(this.selectors.availabilityContainer);
                        e && (this.storeAvailability = new theme.StoreAvailability(e));
                    },
                    productSetup: function () {
                        this.setImageSizes(),
                            this.initImageZoom(),
                            this.initModelViewerLibraries(),
                            this.initShopifyXrLaunch();
                    },
                    setImageSizes: function () {
                        var e;
                        this.settings.hasImages &&
                            (e = this.firstProductImage.currentSrc) &&
                            (this.settings.imageSize = theme.Images.imageSize(e));
                    },
                    addIdToRecentlyViewed: function () {
                        var e = this.container.getAttribute("data-product-handle"),
                            t = this.container.getAttribute("data-product-url"),
                            i = this.container.getAttribute("data-aspect-ratio"),
                            s = this.container.getAttribute("data-img-url");
                        theme.recentlyViewed.recent.hasOwnProperty(e) && delete theme.recentlyViewed.recent[e],
                            (theme.recentlyViewed.recent[e] = { url: t, aspectRatio: i, featuredImage: s }),
                            theme.config.hasLocalStorage &&
                                window.localStorage.setItem(
                                    "theme-recent",
                                    JSON.stringify(theme.recentlyViewed.recent)
                                );
                    },
                    initVariants: function () {
                        var e,
                            t,
                            i = this.container.querySelector(this.selectors.variantsJson);
                        i &&
                            ((this.variantsObject = JSON.parse(i.innerHTML)),
                            (i = !!this.container.querySelector(pt)),
                            (t = {
                                container: this.container,
                                enableHistoryState: this.settings.enableHistoryState,
                                singleOptionSelector: this.selectors.singleOptionSelector,
                                originalSelectorId: this.selectors.originalSelectorId,
                                variants: this.variantsObject,
                                dynamicVariantsEnabled: i,
                            }),
                            (e = this.container.querySelectorAll(this.selectors.variantColorSwatch)).length &&
                                e.forEach((s) => {
                                    s.addEventListener(
                                        "change",
                                        function (e) {
                                            var t = s.dataset.colorName,
                                                i = s.dataset.colorIndex;
                                            this.updateColorName(t, i);
                                        }.bind(this)
                                    );
                                }),
                            (this.variants = new theme.Variants(t)),
                            this.storeAvailability &&
                                ((e = (this.variants.currentVariant || this.variants.variants[0]).id),
                                this.storeAvailability.updateContent(e),
                                this.container.on(
                                    "variantChange" + this.settings.namespace,
                                    this.updateAvailability.bind(this)
                                )),
                            this.container.on(
                                "variantChange" + this.settings.namespace,
                                this.updateCartButton.bind(this)
                            ),
                            this.container.on(
                                "variantImageChange" + this.settings.namespace,
                                this.updateVariantImage.bind(this)
                            ),
                            this.container.on(
                                "variantPriceChange" + this.settings.namespace,
                                this.updatePrice.bind(this)
                            ),
                            this.container.on(
                                "variantUnitPriceChange" + this.settings.namespace,
                                this.updateUnitPrice.bind(this)
                            ),
                            this.container.querySelector(this.selectors.sku) &&
                                this.container.on(
                                    "variantSKUChange" + this.settings.namespace,
                                    this.updateSku.bind(this)
                                ),
                            (t = this.container.querySelector(this.selectors.inventory)) &&
                                ((this.settings.inventory = !0),
                                (this.settings.inventoryThreshold = t.dataset.threshold),
                                this.updateInventory({ detail: { variant: this.variants.currentVariant } }),
                                this.container.on(
                                    "variantChange" + this.settings.namespace,
                                    this.updateInventory.bind(this)
                                )),
                            i &&
                                (e = this.container.querySelector(this.selectors.currentVariantJson)) &&
                                (t = this.container.querySelector(ht)) &&
                                new theme.VariantAvailability({
                                    container: this.container,
                                    namespace: this.settings.namespace,
                                    type: t.dataset.type,
                                    variantsObject: this.variantsObject,
                                    currentVariantObject: JSON.parse(e.innerHTML),
                                }),
                            this.settings.imageSetName) &&
                            ((i = this.container.querySelector(
                                '.variant-input-wrap[data-handle="' + this.settings.imageSetName + '"]'
                            ))
                                ? ((this.settings.imageSetIndex = i.dataset.index),
                                  this.container.on(
                                      "variantChange" + this.settings.namespace,
                                      this.updateImageSet.bind(this)
                                  ))
                                : (this.settings.imageSetName = null));
                    },
                    initQtySelector: function () {
                        this.container.querySelectorAll(".js-qty__wrapper").forEach((e) => {
                            new theme.QtySelector(e, { namespace: ".product" });
                        });
                    },
                    initAjaxProductForm: function () {
                        new theme.AjaxProduct(this.cache.form);
                    },
                    updateColorName: function (e, t) {
                        this.container.querySelector(this.selectors.colorLabel + `[data-index="${t}"`).textContent = e;
                    },
                    updateCartButton: function (e) {
                        var e = e.detail.variant,
                            t = this.container.querySelector(this.selectors.addToCart),
                            i = this.container.querySelector(this.selectors.addToCartText);
                        t &&
                            (e
                                ? e.available
                                    ? (t.classList.remove(q),
                                      (t.disabled = !1),
                                      (e = i.dataset.defaultText),
                                      (i.textContent = e))
                                    : (t.classList.add(q), (t.disabled = !0), (i.textContent = theme.strings.soldOut))
                                : (t.classList.add(q), (t.disabled = !0), (i.textContent = theme.strings.unavailable)));
                    },
                    updatePrice: function (e) {
                        var t,
                            e = e.detail.variant;
                        e &&
                            ((this.cache.price.innerHTML = theme.Currency.formatMoney(
                                e.price,
                                theme.settings.moneyFormat
                            )),
                            e.compare_at_price > e.price
                                ? ((this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(
                                      e.compare_at_price,
                                      theme.settings.moneyFormat
                                  )),
                                  this.cache.priceWrapper.classList.remove(A),
                                  this.cache.price.classList.add(at),
                                  this.cache.comparePriceA11y.setAttribute("aria-hidden", "false"),
                                  this.cache.priceA11y.setAttribute("aria-hidden", "false"),
                                  (t = e.compare_at_price - e.price),
                                  (t =
                                      "percent" == theme.settings.saveType
                                          ? Math.round((100 * t) / e.compare_at_price) + "%"
                                          : theme.Currency.formatMoney(t, theme.settings.moneyFormat)),
                                  this.cache.savePrice.classList.remove(A),
                                  (this.cache.savePrice.innerHTML = theme.strings.savePrice.replace(
                                      "[saved_amount]",
                                      t
                                  )))
                                : (this.cache.priceWrapper && this.cache.priceWrapper.classList.add(A),
                                  this.cache.savePrice.classList.add(A),
                                  this.cache.price.classList.remove(at),
                                  this.cache.comparePriceA11y &&
                                      this.cache.comparePriceA11y.setAttribute("aria-hidden", "true"),
                                  this.cache.priceA11y.setAttribute("aria-hidden", "true")));
                    },
                    updateUnitPrice: function (e) {
                        e = e.detail.variant;
                        e && e.unit_price
                            ? ((this.container.querySelector(this.selectors.unitPrice).innerHTML =
                                  theme.Currency.formatMoney(e.unit_price, theme.settings.moneyFormat)),
                              (this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML =
                                  theme.Currency.getBaseUnit(e)),
                              this.container.querySelector(this.selectors.unitWrapper).classList.remove(A))
                            : this.container.querySelector(this.selectors.unitWrapper).classList.add(A);
                    },
                    imageSetArguments: function (e) {
                        if ((e = e || (this.variants ? this.variants.currentVariant : null)))
                            return (
                                (e = this.settings.currentImageSet =
                                    this.getImageSetName(e[this.settings.imageSetIndex])),
                                (e = this.settings.imageSetName + "_" + e),
                                (this.settings.currentSlideIndex = 0),
                                {
                                    cellSelector: '[data-group="' + e + '"]',
                                    imageSet: e,
                                    initialIndex: this.settings.currentSlideIndex,
                                }
                            );
                    },
                    updateImageSet: function (e) {
                        var t,
                            e = e ? e.detail.variant : this.variants ? this.variants.currentVariant : null;
                        e &&
                            ((t = this.getImageSetName(e[this.settings.imageSetIndex])),
                            this.settings.currentImageSet !== t) &&
                            this.initProductSlider(e);
                    },
                    updateImageSetThumbs: function (t) {
                        this.cache.thumbSlider.querySelectorAll(".product__thumb-item").forEach((e) => {
                            e.classList.toggle(A, e.dataset.group !== t);
                        });
                    },
                    getImageSetName: function (e) {
                        return e
                            .toLowerCase()
                            .replace(/[^a-z0-9]+/g, "-")
                            .replace(/-$/, "")
                            .replace(/^-/, "");
                    },
                    updateSku: function (e) {
                        var e = e.detail.variant,
                            t = "";
                        e && (e.sku && (t = e.sku), (this.container.querySelector(this.selectors.sku).textContent = t));
                    },
                    updateInventory: function (e) {
                        var t,
                            i,
                            s,
                            n,
                            e = e.detail.variant;
                        e
                            ? e.inventory_management
                                ? "shopify" === e.inventory_management &&
                                  window.inventories &&
                                  window.inventories[this.productId] &&
                                  (({
                                      quantity: t,
                                      policy: i,
                                      incoming: s,
                                      next_incoming_date: n,
                                  } = window.inventories[this.productId][e.id] || {}),
                                  this.toggleInventoryQuantity(void 0, t),
                                  (s && !e.available) || (t <= 0 && "continue" === i)
                                      ? this.toggleIncomingInventory(!0, n, i)
                                      : this.toggleIncomingInventory(!1))
                                : (this.toggleInventoryQuantity("visible", !1), this.toggleIncomingInventory(!1))
                            : (this.toggleInventoryQuantity("hidden", !1), this.toggleIncomingInventory(!1));
                    },
                    updateAvailability: function (e) {
                        e = e.detail.variant;
                        e && this.storeAvailability.updateContent(e.id);
                    },
                    toggleInventoryQuantity: function (t = void 0, i) {
                        var s = this.container.querySelector(this.selectors.inventory),
                            n = s.closest(".sales-point");
                        if (t && "hidden" === t) n && n.classList.add(A);
                        else {
                            let e = !1;
                            parseInt(i) <= parseInt(this.settings.inventoryThreshold) && 0 < parseInt(i) && (e = !0),
                                0 < parseInt(i) || (t && "visible" === t)
                                    ? (e
                                          ? (s.parentNode.classList.add(x),
                                            (s.textContent = (
                                                1 < i ? theme.strings.otherStockLabel : theme.strings.oneStockLabel
                                            ).replace("[count]", i)))
                                          : (s.parentNode.classList.remove(x),
                                            (s.textContent = theme.strings.inStockLabel)),
                                      n && n.classList.remove(A))
                                    : n && n.classList.add(A);
                        }
                    },
                    toggleIncomingInventory: function (e, t, i) {
                        var s,
                            n,
                            o = this.container.querySelector(this.selectors.incomingInventory),
                            a = o.querySelector(".icon-and-text");
                        o &&
                            ((s = "true" === o.dataset.enabled),
                            (n = o.querySelector(".js-incoming-text")),
                            s && e
                                ? ((n.textContent = t
                                      ? theme.strings.willBeInStockAfter.replace("[date]", t)
                                      : theme.strings.waitingForStock),
                                  o.classList.remove(A),
                                  a && ("continue" !== i ? a.classList.add(x) : a.classList.remove(x)))
                                : o.classList.add(A));
                    },
                    videoSetup: function () {
                        var e = this.cache.mainSlider.querySelectorAll(T);
                        if (!e.length) return !1;
                        e.forEach((e) => {
                            var t = e.dataset.videoType;
                            "youtube" === t
                                ? this.initYoutubeVideo(e)
                                : "vimeo" === t
                                  ? this.initVimeoVideo(e)
                                  : "mp4" === t && this.initMp4Video(e);
                        });
                    },
                    initYoutubeVideo: function (e) {
                        C[e.id] = new theme.YouTube(e.id, {
                            videoId: e.dataset.videoId,
                            videoParent: O,
                            autoplay: !1,
                            style: e.dataset.videoStyle,
                            loop: e.dataset.videoLoop,
                            events: {
                                onReady: this.youtubePlayerReady.bind(this),
                                onStateChange: this.youtubePlayerStateChange.bind(this),
                            },
                        });
                    },
                    initVimeoVideo: function (e) {
                        C[e.id] = new theme.VimeoPlayer(e.id, e.dataset.videoId, {
                            videoParent: O,
                            autoplay: !1,
                            style: e.dataset.videoStyle,
                            loop: e.dataset.videoLoop,
                        });
                    },
                    youtubePlayerReady: function (e) {
                        var t,
                            i,
                            e = e.target.getIframe().id;
                        C[e] &&
                            ((i = (t = C[e]).videoPlayer),
                            "sound" !== t.options.style && i.mute(),
                            t.parent.classList.remove("loading"),
                            t.parent.classList.add("loaded"),
                            t.parent.classList.add("video-interactable"),
                            this._isFirstSlide(e)) &&
                            "sound" !== t.options.style &&
                            i.playVideo();
                    },
                    _isFirstSlide: function (e) {
                        return this.cache.mainSlider.querySelector(lt + " #" + e);
                    },
                    youtubePlayerStateChange: function (e) {
                        var t = e.target.getIframe().id,
                            i = C[t];
                        switch (e.data) {
                            case -1:
                                i.attemptedToPlay && i.parent.classList.add("video-interactable");
                                break;
                            case 0:
                                i && "true" === i.options.loop && i.videoPlayer.playVideo();
                                break;
                            case 3:
                                i.attemptedToPlay = !0;
                        }
                    },
                    initMp4Video: function (e) {
                        (C[e.id] = { id: e.id, type: "mp4" }), this._isFirstSlide(e.id) && this.playMp4Video(e.id);
                    },
                    stopVideos: function () {
                        for (var [e, t] of Object.entries(C))
                            t.videoPlayer
                                ? "function" == typeof t.videoPlayer.stopVideo && t.videoPlayer.stopVideo()
                                : "mp4" === t.type && this.stopMp4Video(t.id);
                    },
                    _getVideoType: function (e) {
                        return e.getAttribute("data-video-type");
                    },
                    _getVideoDivId: function (e) {
                        return e.id;
                    },
                    playMp4Video: function (e) {
                        var t = this.container.querySelector("#" + e),
                            e = t.play();
                        void 0 !== e &&
                            e
                                .then(function () {})
                                .catch(function (e) {
                                    t.setAttribute("controls", ""),
                                        t.closest(O).setAttribute("data-video-style", "unmuted");
                                });
                    },
                    stopMp4Video: function (e) {
                        e = this.container.querySelector("#" + e);
                        e && "function" == typeof e.pause && e.pause();
                    },
                    initImageZoom: function () {
                        var e = this.container.querySelector(this.selectors.imageContainer);
                        e &&
                            (new theme.Photoswipe(e, this.sectionId),
                            e.addEventListener(
                                "photoswipe:afterChange",
                                function (e) {
                                    this.flickity && this.flickity.goToSlide(e.detail.index);
                                }.bind(this)
                            ));
                    },
                    getThumbIndex: function (e) {
                        return e.dataset.index;
                    },
                    updateVariantImage: function (e) {
                        (e = e.detail.variant),
                            theme.Images.getSizedImageUrl(e.featured_media.preview_image.src, this.settings.imageSize),
                            (e = this.container.querySelector(
                                '.product__thumb[data-id="' + e.featured_media.id + '"]'
                            )),
                            (e = this.getThumbIndex(e));
                        void 0 !== e && this.flickity && this.flickity.goToSlide(e);
                    },
                    initProductSlider: function (e) {
                        var t;
                        this.cache.mainSlider.querySelectorAll(ct).length <= 1
                            ? (t = this.cache.mainSlider.querySelector(ct)) && t.classList.add("is-selected")
                            : (this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy(),
                              e ||
                                  ((t = this.cache.mainSlider.querySelector(lt)),
                                  (this.settings.currentSlideIndex = this._slideIndex(t))),
                              (t = {
                                  dragThreshold: 25,
                                  adaptiveHeight: !0,
                                  avoidReflow: !0,
                                  initialIndex: this.settings.currentSlideIndex,
                                  childNav: this.cache.thumbSlider,
                                  childNavScroller: this.cache.thumbScroller,
                                  childVertical: "beside" === this.cache.thumbSlider.dataset.position,
                                  pageDots: !0,
                                  wrapAround: !0,
                                  callbacks: {
                                      onInit: this.onSliderInit.bind(this),
                                      onChange: this.onSlideChange.bind(this),
                                  },
                              }),
                              this.settings.imageSetName &&
                                  ((e = this.imageSetArguments(e)),
                                  (t = Object.assign({}, t, e)),
                                  this.updateImageSetThumbs(t.imageSet)),
                              (this.flickity = new theme.Slideshow(this.cache.mainSlider, t)));
                    },
                    onSliderInit: function (e) {
                        this.settings.imageSetName && this.prepMediaOnSlide(e);
                    },
                    onSlideChange: function (e) {
                        var t, i;
                        this.flickity &&
                            ((t = this.cache.mainSlider.querySelector(
                                '.product-main-slide[data-index="' + this.settings.currentSlideIndex + '"]'
                            )),
                            (i = this.settings.imageSetName
                                ? this.cache.mainSlider.querySelectorAll(".flickity-slider .product-main-slide")[e]
                                : this.cache.mainSlider.querySelector('.product-main-slide[data-index="' + e + '"]')),
                            t.setAttribute("tabindex", "-1"),
                            i.setAttribute("tabindex", 0),
                            this.stopMediaOnSlide(t),
                            this.prepMediaOnSlide(i),
                            (this.settings.currentSlideIndex = e));
                    },
                    stopMediaOnSlide(e) {
                        var t = e.querySelector(T);
                        if (t) {
                            var i = this._getVideoType(t),
                                t = this._getVideoDivId(t);
                            if ("youtube" === i) {
                                if (C[t].videoPlayer) return void C[t].videoPlayer.stopVideo();
                            } else if ("mp4" === i) return void this.stopMp4Video(t);
                        }
                        i = e.querySelector(this.selectors.media);
                        i && i.dispatchEvent(new CustomEvent("mediaHidden", { bubbles: !0, cancelable: !0 }));
                    },
                    prepMediaOnSlide(e) {
                        var t = e.querySelector(T);
                        if (t) {
                            this.flickity.reposition();
                            var i = this._getVideoType(t),
                                t = this._getVideoDivId(t);
                            if ("youtube" === i) {
                                if (C[t].videoPlayer && "sound" !== C[t].options.style)
                                    return void C[t].videoPlayer.playVideo();
                            } else "mp4" === i && this.playMp4Video(t);
                        }
                        i = e.querySelector(this.selectors.media);
                        i &&
                            (i.dispatchEvent(new CustomEvent("mediaVisible", { bubbles: !0, cancelable: !0 })),
                            e.querySelector(".shopify-model-viewer-ui__button").setAttribute("tabindex", 0),
                            e.querySelector(".product-single__close-media").setAttribute("tabindex", 0));
                    },
                    _slideIndex: function (e) {
                        return e.getAttribute("data-index");
                    },
                    openModalProduct: function () {
                        var e,
                            t = !1;
                        this.settings.modalInit
                            ? (t = !0)
                            : ((this.blocksHolder = this.container.querySelector(mt)),
                              (e = this.blocksHolder.dataset.url),
                              fetch(e)
                                  .then(function (e) {
                                      return e.text();
                                  })
                                  .then(
                                      function (e) {
                                          var t,
                                              i = new DOMParser().parseFromString(e, "text/html").querySelector(ut),
                                              e =
                                                  (i.querySelectorAll("[id]").forEach((e) => {
                                                      var t = e.getAttribute("id"),
                                                          e =
                                                              (e.setAttribute("id", t + "-modal"),
                                                              i.querySelector(`[for="${t}"]`)),
                                                          e =
                                                              (e && e.setAttribute("for", t + "-modal"),
                                                              i.querySelector(`[aria-controls="${t}"]`));
                                                      e && e.setAttribute("aria-controls", t + "-modal");
                                                  }),
                                                  i.querySelector(this.selectors.form));
                                          e &&
                                              ((t = e.getAttribute("id")),
                                              i.querySelectorAll("[form]").forEach((e) => {
                                                  e.setAttribute("form", t);
                                              })),
                                              (this.blocksHolder.innerHTML = ""),
                                              this.blocksHolder.append(i),
                                              this.blocksHolder.classList.add("product-form-holder--loaded"),
                                              this.cacheElements(),
                                              this.formSetup(),
                                              this.updateModalProductInventory(),
                                              Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(),
                                              theme.collapsibles.init(this.container),
                                              document.dispatchEvent(
                                                  new CustomEvent("quickview:loaded", {
                                                      detail: { productId: this.productId },
                                                  })
                                              );
                                      }.bind(this)
                                  ),
                              this.productSetup(),
                              this.videoSetup(),
                              !this.settings.imageSetName || this.variants
                                  ? this.initProductSlider()
                                  : document.addEventListener(
                                        "quickview:loaded",
                                        function (e) {
                                            e.detail.productId === this.productId && this.initProductSlider();
                                        }.bind(this)
                                    ),
                              this.customMediaListners(),
                              this.addIdToRecentlyViewed(),
                              (this.settings.modalInit = !0)),
                            AOS.refreshHard(),
                            document.dispatchEvent(
                                new CustomEvent("quickview:open", {
                                    detail: { initialized: t, productId: this.productId },
                                })
                            );
                    },
                    updateModalProductInventory: function () {
                        (window.inventories = window.inventories || {}),
                            this.container.querySelectorAll(".js-product-inventory-data").forEach((e) => {
                                var t = e.dataset.productId;
                                (window.inventories[t] = {}),
                                    e.querySelectorAll(".js-variant-inventory-data").forEach((e) => {
                                        window.inventories[t][e.dataset.id] = {
                                            quantity: e.dataset.quantity,
                                            policy: e.dataset.policy,
                                            incoming: e.dataset.incoming,
                                            next_incoming_date: e.dataset.date,
                                        };
                                    });
                            });
                    },
                    closeModalProduct: function () {
                        this.stopVideos();
                    },
                    initModelViewerLibraries: function () {
                        var e = this.container.querySelectorAll(this.selectors.media);
                        e.length < 1 || theme.ProductMedia.init(e, this.sectionId);
                    },
                    initShopifyXrLaunch: function () {
                        document.addEventListener(
                            "shopify_xr_launch",
                            function () {
                                this.container
                                    .querySelector(
                                        this.selectors.productMediaWrapper + ":not(." + self.classes.hidden + ")"
                                    )
                                    .dispatchEvent(new CustomEvent("xrLaunch", { bubbles: !0, cancelable: !0 }));
                            }.bind(this)
                        );
                    },
                    customMediaListners: function () {
                        document.querySelectorAll(this.selectors.closeMedia).forEach((e) => {
                            e.addEventListener(
                                "click",
                                function () {
                                    var e = this.cache.mainSlider.querySelector(dt).querySelector(this.selectors.media);
                                    e &&
                                        e.dispatchEvent(
                                            new CustomEvent("mediaHidden", { bubbles: !0, cancelable: !0 })
                                        );
                                }.bind(this)
                            );
                        });
                        var e = this.container.querySelectorAll("model-viewer");
                        e.length &&
                            e.forEach((e) => {
                                e.addEventListener(
                                    "shopify_model_viewer_ui_toggle_play",
                                    function (e) {
                                        this.mediaLoaded(e);
                                    }.bind(this)
                                ),
                                    e.addEventListener(
                                        "shopify_model_viewer_ui_toggle_pause",
                                        function (e) {
                                            this.mediaUnloaded(e);
                                        }.bind(this)
                                    );
                            });
                    },
                    mediaLoaded: function (e) {
                        this.container.querySelectorAll(this.selectors.closeMedia).forEach((e) => {
                            e.classList.remove(A);
                        }),
                            this.flickity && this.flickity.setDraggable(!1);
                    },
                    mediaUnloaded: function (e) {
                        this.container.querySelectorAll(this.selectors.closeMedia).forEach((e) => {
                            e.classList.add(A);
                        }),
                            this.flickity && this.flickity.setDraggable(!0);
                    },
                    onUnload: function () {
                        theme.ProductMedia.removeSectionModels(this.sectionId),
                            this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy();
                    },
                })),
                ci)),
            (theme.RecentlyViewed =
                ((P = !1),
                (di.prototype = Object.assign({}, di.prototype, {
                    init: function () {
                        var t;
                        P ||
                            ((P = !0),
                            0 === Object.keys(theme.recentlyViewed.recent).length &&
                            theme.recentlyViewed.recent.constructor === Object
                                ? this.container.classList.add("hide")
                                : ((this.outputContainer = document.getElementById("RecentlyViewed-" + this.sectionId)),
                                  (this.handle = this.container.getAttribute("data-product-handle")),
                                  (t = []),
                                  Object.keys(theme.recentlyViewed.recent).forEach(
                                      function (e) {
                                          "undefined" !== e && t.push(this.getProductInfo(e));
                                      }.bind(this)
                                  ),
                                  Promise.all(t).then(
                                      function (e) {
                                          this.setupOutput(e), this.captureProductDetails(e);
                                      }.bind(this)
                                  )));
                    },
                    getProductInfo: function (i) {
                        return new Promise(function (t, e) {
                            theme.recentlyViewed.productInfo.hasOwnProperty(i)
                                ? t(theme.recentlyViewed.productInfo[i])
                                : fetch("/products/" + i + ".js")
                                      .then(function (e) {
                                          return e.text();
                                      })
                                      .then(function (e) {
                                          t(e);
                                      });
                        });
                    },
                    setupOutput: function (s) {
                        var n = [],
                            e = this.container.getAttribute("data-recent-count");
                        Object.keys(s).forEach(
                            function (e) {
                                var t, i;
                                s[e] &&
                                    (e = JSON.parse(s[e])).handle !== this.handle &&
                                    void 0 !== e.handle &&
                                    ((e.url = (theme.recentlyViewed.recent[e.handle] || e).url),
                                    (e.image_responsive_url = theme.Images.buildImagePath(e.featured_image)),
                                    (e.image_responsive_urls = theme.Images.buildImagePath(
                                        e.featured_image,
                                        [180, 360, 540, 720, 900]
                                    )),
                                    (e.image_aspect_ratio = theme.recentlyViewed.recent[e.handle].aspectRatio),
                                    (t = e.variants[0]) &&
                                        t.unit_price &&
                                        ((i = ""),
                                        t.unit_price_measurement &&
                                            (1 != t.unit_price_measurement.reference_value &&
                                                (i += t.unit_price_measurement.reference_value + " "),
                                            (i += t.unit_price_measurement.reference_unit)),
                                        (e.unit_price = theme.Currency.formatMoney(t.unit_price)),
                                        "" != i) &&
                                        (e.unit_price += "/" + i),
                                    n.unshift(e));
                            }.bind(this)
                        ),
                            0 === n.length
                                ? this.container.classList.add("hide")
                                : ((e = theme.buildProductGridItem(
                                      n.slice(0, e),
                                      this.gridItemWidth,
                                      this.rowOf,
                                      this.imageSizes
                                  )),
                                  (this.outputContainer.innerHTML = e),
                                  AOS && AOS.refreshHard());
                    },
                    captureProductDetails: function (e) {
                        for (var t = 0; t < e.length; t++) {
                            var i = e[t];
                            theme.recentlyViewed.productInfo[i.handle] = i;
                        }
                        theme.config.hasSessionStorage &&
                            sessionStorage.setItem("recent-products", JSON.stringify(theme.recentlyViewed.productInfo));
                    },
                    onUnload: function () {
                        P = !1;
                    },
                })),
                di)),
            (theme.Testimonials =
                ((gt = {
                    adaptiveHeight: !0,
                    avoidReflow: !0,
                    pageDots: !0,
                    prevNextButtons: !0,
                    contain: !0,
                    wrapAround: !1,
                    cellAlign: "left",
                }),
                (li.prototype = Object.assign({}, li.prototype, {
                    init: function () {
                        this.slideshow.dataset.count <= 3 && (gt.wrapAround = !1),
                            (this.flickity = new theme.Slideshow(this.slideshow, gt)),
                            2 < this.slideshow.dataset.count &&
                                (this.timeout = setTimeout(
                                    function () {
                                        this.flickity.goToSlide(1);
                                    }.bind(this),
                                    1e3
                                ));
                    },
                    onUnload: function () {
                        this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy();
                    },
                    onDeselect: function () {
                        this.flickity && "function" == typeof this.flickity.play && this.flickity.play();
                    },
                    onBlockSelect: function (e) {
                        (e = this.slideshow.querySelector(".testimonials-slide--" + e.detail.blockId)),
                            (e = parseInt(e.dataset.index));
                        clearTimeout(this.timeout),
                            this.flickity &&
                                "function" == typeof this.flickity.pause &&
                                (this.flickity.goToSlide(e), this.flickity.pause());
                    },
                    onBlockDeselect: function () {
                        this.flickity && "function" == typeof this.flickity.play && this.flickity.play();
                    },
                })),
                li)),
            (theme.isStorageSupported = function (e) {
                if (window.self !== window.top) return !1;
                var t;
                "session" === e && (t = window.sessionStorage), "local" === e && (t = window.localStorage);
                try {
                    return t.setItem("test", "1"), t.removeItem("test"), !0;
                } catch (e) {
                    return !1;
                }
            }),
            (theme.reinitProductGridItem = function (e) {
                AOS && AOS.refreshHard(),
                    document.documentElement.classList.contains("modal-open") || theme.initQuickShop(),
                    theme.collapsibles.init();
            }),
            (theme.config.hasSessionStorage = theme.isStorageSupported("session")),
            (theme.config.hasLocalStorage = theme.isStorageSupported("local")),
            AOS.init({ easing: "ease-out-quad", once: !0, offset: 60, disableMutationObserver: !0 }),
            theme.config.hasLocalStorage &&
                ((theme.recentlyViewed.localStorage = window.localStorage.getItem("theme-recent")),
                theme.recentlyViewed.localStorage) &&
                (theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage)),
            (theme.recentlyViewed.productInfo =
                theme.config.hasSessionStorage && sessionStorage["recent-products"]
                    ? JSON.parse(sessionStorage["recent-products"])
                    : {}),
            (theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches),
            matchMedia(theme.config.mediaQuerySmall).addListener(function (e) {
                e.matches
                    ? ((theme.config.bpSmall = !0), document.dispatchEvent(new CustomEvent("matchSmall")))
                    : ((theme.config.bpSmall = !1), document.dispatchEvent(new CustomEvent("unmatchSmall")));
            }),
            (theme.initGlobals = function () {
                theme.collapsibles.init(), theme.videoModal();
            }),
            (M = function () {
                var e;
                (theme.sections = new theme.Sections()),
                    theme.sections.register("slideshow-section", theme.SlideshowSection),
                    theme.sections.register("header", theme.HeaderSection),
                    theme.sections.register("product", theme.Product),
                    theme.sections.register("blog", theme.Blog),
                    theme.sections.register("password-header", theme.PasswordHeader),
                    theme.sections.register("photoswipe", theme.Photoswipe),
                    theme.sections.register("background-image", theme.BackgroundImage),
                    theme.sections.register("testimonials", theme.Testimonials),
                    theme.sections.register("video-section", theme.VideoSection),
                    theme.sections.register("map", theme.Maps),
                    theme.sections.register("footer-section", theme.FooterSection),
                    theme.sections.register("store-availability", theme.StoreAvailability),
                    theme.sections.register("recently-viewed", theme.RecentlyViewed),
                    theme.sections.register("newsletter-popup", theme.NewsletterPopup),
                    theme.sections.register("collection-header", theme.CollectionHeader),
                    theme.sections.register("collection-grid", theme.Collection),
                    theme.initGlobals(),
                    theme.initQuickShop(),
                    theme.rteInit(),
                    document.body.classList.contains("template-cart") &&
                        (e = document.getElementById("CartPageForm")) &&
                        new theme.CartForm(e),
                    theme.settings.isCustomerTemplate && theme.customerTemplates(),
                    document.dispatchEvent(new CustomEvent("page:loaded"));
            }),
            "loading" != document.readyState ? M() : document.addEventListener("DOMContentLoaded", M);
    })();
